import "./BookAppointmentFlowModalComponent.scss";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import {ImageConfig, Misc} from "../../../../constants";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {Col, Row, Typography} from "antd";
import {setBookingAppointmentFlowNavigation} from "../../../../store/actions/navigation.action";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import FormikInputComponent from "../../../../shared/components/form-controls/formik-input/FormikInputComponent";
import FormikPhoneInputComponent from "../../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import * as Yup from "yup";
import _ from "lodash";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";
import FormikOTPComponent from "../../../../shared/components/form-controls/formik-otp/FormikOtpComponent";
import {setLoggedInUserData, setLoggedInUserToken} from "../../../../store/actions/account.action";
import LinkComponent from "../../../../shared/components/link/LinkComponent";
import FormDebuggerComponent from "../../../../shared/components/form-debugger/FormDebuggerComponent";
import FormikDatePickerComponent
    from "../../../../shared/components/form-controls/formik-date-picker/FormikDatePickerComponent";
import moment from "moment/moment";
import FormikSelectDropdownComponent
    from "../../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import {IClientBasicDetails} from "../../../../shared/models/client.model";
import ProviderDetailsModalComponent from "../provider-details-modal/ProviderDetailsComponent";
import BookAppointmentCalender
    from "../../../../shared/components/book-appoiinterment-calender/BookAppointmentCalender";
import InputComponent from "../../../../shared/components/form-controls/input/InputComponent";
import AttendanceAndCancellationPolicyComponent
    from "../../../transaction/attendance-and-cancellation-policy/AttendanceAndCancellationPolicyComponent";
import CheckBoxComponent from "../../../../shared/components/form-controls/check-box/CheckBoxComponent";
import IconButtonComponent from "../../../../shared/components/icon-button/IconButtonComponent";
import ToolTipComponent from "../../../../shared/components/tool-tip/ToolTipComponent";
import FormikRadioButtonGroupComponent
    from "../../../../shared/components/form-controls/formik-radio-button-group/FormikRadioButtonGroupComponent";
import commonService from "../../../../shared/services/common.service";
import {getAccessibleAccounts} from "../../../../store/actions/static-data.action";
import {useNavigate} from "react-router-dom";
import momentTimezone from "moment-timezone";
import CategoryServiceDetailsComponent from "../category-service-details-modal/CategoryServiceDetailsComponent";
import ConfirmationModal from "../../../../shared/components/confirmation-popup/ConfirmationComponent";
import BookAppointmentFollowUpCalender
    from "../../../../shared/components/follow-up-calender/BookAppointmentFollowupCalender";
import SelectDropdownComponent
    from "../../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";

const {Paragraph} = Typography;

interface BookAppointmentFlowModalComponentProps {
    serviceCategoryDetails?: any;
    facilityDetails?: any;
    setIsBookAppointmentFlowModalOpen?: any;
    facilityProviderDetails?: any;
    fetchProviderDetails?: any;
    providerDetails?: any;
    isProviderDetailsLoading?: any
    setPaymentSuccessParentConfirmation?: any;
}

const ReturningClientLoginFormValidationSchema = Yup.object({
    login_mode: Yup.string(),
    username: Yup.string()
        .when("login_mode", {
            is: (login_mode: 'email' | 'phone') => login_mode === 'email',
            then: Yup.string().required('Email Address is required').email('Please enter a valid email address'),
            otherwise: Yup.string().required('Phone Number is required'),
        }),
    client_id: Yup.string().required('Client Id is required').min(8, '').max(8),

});

const otpFormValidationSchema = Yup.object({
    login_mode: Yup.string(),
    username: Yup.string().required('Username is required'),
    otp: Yup.string().required('OTP is required').min(6, ''),
});

const clientFormValidationSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    dob: Yup.mixed().required('Date of birth is required'),
    gender: Yup.string().required('Gender is required'),
    primary_email: Yup.string()
        .email('Invalid email format').required('Primary email is required'),
    primary_contact_info: Yup.object().shape({
        _phone: Yup.string().required('Cell Phone number is required')
    }),
});

const someOneElseFormValidationSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    dob: Yup.mixed().required('Date of birth is required'),
    gender: Yup.string().required('Gender is required'),
    relationship: Yup.string().required('Relationship is required'),
    primary_email: Yup.string()
        .email('Invalid email format')
        .when('is_dependent', {
            is: false,
            then: Yup.string().required('Primary email is required')
        }),
    primary_contact_info: Yup.object().shape({
        phone: Yup.string().when('is_dependent', {
            is: false,
            then: Yup.string().required('Phone number is required')
        })
    }),
    is_dependent: Yup.boolean().required('Dependency status is required')
});

const LoginFormInitialValues = {
    login_mode: "email",
    username: "",
    client_id: ""
}

const OTPFormInitialValues = {
    login_mode: "email",
    username: "",
    otp: ""
}

const clientFormInitialValue: any = {
    first_name: '',
    last_name: '',
    dob: '',
    gender: '',
    primary_email: '',
    primary_contact_info: {
        _phone: ''
    },
}

const someoneElseFormInitialValue: any = {
    first_name: '',
    last_name: '',
    dob: '',
    gender: '',
    relationship: '',
    primary_email: '',
    primary_contact_info: {
        phone: ''
    },
    is_dependent: true,
}

const OTP_VALIDITY = 300;
const COUPON_CODE_VALIDATOR = 600;

const BookAppointmentFlowModalComponent = (props: BookAppointmentFlowModalComponentProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    //   below are the book-appointment navigation keys stored in Redux
    // "category_selection_screen" | "category_service_selection_screen" | "injury_type_selection_screen" | "time_rate_slot_selection_screen" | "client_type_selection" | "client_form_based_client_type_selection_screen" | "otp_verification_screen" | "booking_appointment_for_screen" | "someone_else_form_screen" | "select_provider_screen" | "select_date_and_time_screen" | "secure_checkout_screen"
    //Getting category details facility Details and Modal Status from props
    const {
        serviceCategoryDetails,
        facilityDetails,
        setIsBookAppointmentFlowModalOpen,
        fetchProviderDetails,
        providerDetails,
        isProviderDetailsLoading,
        setPaymentSuccessParentConfirmation
    } = props;
    //navigation selector for booking appointment flow
    const {currentBookingAppointmentFlowNavigation} = useSelector((state: IRootReducerState) => state.navigation);
    //Service List Apis storage state
    const [serviceList, setServiceList] = useState<any>([]);
    const [isServiceListLoading, setIsServiceListLoading] = useState<boolean>(false);
    //category selection state
    const [selectedCategoryDetails, setSelectedCategoryDetails] = useState<any>(null);
    //service selection state
    const [selectedServiceDetails, setSelectedServiceDetails] = useState<any>(null);
    //Injury Type Selection State
    const [selectedInjuryType, setSelectedInjuryType] = useState<string>("");
    //Time and Rate Selection state Storage
    const [selectedTimeDurationAndAmount, setSelectedTimeDurationAndAmount] = useState<any>({});
    // New Or Returning Client State Management
    const [clientNewReturningType] = useState<"new_client" | "returning_client" | "">("");

    const [otpFormInitialValues, setOTPFormInitialValues] = useState<any>(_.cloneDeep(OTPFormInitialValues));
    const [otpTimer, setOtpTimer] = useState<number>(0);
    const [couponTimer, setCouponTimer] = useState<any>(COUPON_CODE_VALIDATOR);
    const [remainingTimeForFollowUpBooking, setRemainingTimeForFollowUpBooking] = useState<any>(-1);
    const [isOtpModalOpen, setIsOtpModalOpen] = useState<boolean>(false);
    const otpIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const couponIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const followUpIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const [isOTPBeingRequested, setIsOTPBeingRequested] = useState<boolean>(false);
    const [internalScreen, setInternalScreen] = useState<any>("booking-for-screen");
    const [isProviderDetailsModalOpen, setIsProviderDetailsModalOpen] = useState<boolean>(false);
    const [selectedProviderDetails, setSelectedProviderDetails] = useState<any>(null);
    const [availableProviderDates, setAvailableProviderDates] = useState<any>([]);
    const [isAvailableProviderDatesLoading, setIsAvailableProviderDatesLoading] = useState<boolean>(false);
    const [availableProviderTimings, setAvailableProviderTimings] = useState<any>([]);
    const [isAvailableProviderTimingsLoading, setIsAvailableProviderTimingsLoading] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] = useState<any>("");
    const [selectedTime, setSelectedTime] = useState<any>(null);
    const [checkOutCode, setCheckOutCode] = useState<any>(null);
    const [couponCodeAppliedData, setCouponCodeAppliedData] = useState<any>(null);
    const [isCouponCodeDataLoading, setIsCouponCodeDataLoading] = useState<boolean>(false);
    const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
    const [isAttendancePolicyChecked, setIsAttendancePolicyChecked] = useState<boolean>(false);
    const {accessibleAccounts} = useSelector((state: IRootReducerState) => state.staticData);
    const [appointmentForType, setAppointmentForType] = useState<string>("");
    const [familyClientDetails, setFamilyClientDetails] = useState<any>(null);
    const [isPaymentSuccessModalOpen, setIsPaymentSuccessModalOpen] = useState(false);
    const [isAppointmentTimeUpModalOpen, setIsAppointmentTimeUpModalOpen] = useState(false);
    const [isCategoryServiceModalOpen, setIsCategoryServiceModalOpen] = useState(false);
    const [isCheckoutConfirmationModalOpen, setIsCheckoutConfirmationModalOpen] = useState(false);
    const [isBookingUnblockedConfirmationModalOpen, setIsBookingUnblockedConfirmationModalOpen] = useState(false);
    const [newClientFormData, setNewClientFormData] = useState<any>(null);
    const [isNewClientAddingModalOpen, setIsNewClientAddingModalOpen] = useState(false);
    const [providerListBasedOnCategoryFacilitySelected, setProviderListBasedOnCategoryFacilitySelected] = useState<any>(null);
    const [blockSessionId, setBlockSessionId] = useState<any>(null);
    const [caseList, setCaseList] = useState<any>(null);
    const [isCaseListLoading, setIsCaseListLoading] = useState<boolean>(false);
    const [selectedCase, setSelectedCase] = useState<any>(null);
    const [selectedDateForProviderFollowUp, setSelectedDateForProviderFollowUp] = useState<any>(null);
    const [isContactUsConfirmationModalOpen, setIsContactUsConfirmationModalOpen] = useState(false);
    const [appointmentData, setAppointmentData] = useState<any>({
        client_id: "",
        category_id: "",
        service_id: "",
        facility_id: "",
        appointment_type: "followup_consultation",
        consultation_id: "",
        record_id: "",
        duration: 0,
        amount: 0,
        sessions: [],
    });

    const [previouslySelectedRow, setPreviouslySelectedRow] = useState<any>(null);

    const [rowId, setRowId] = useState<any>(null);
    const [newlyAddedRowId, setNewlyAddedRowId] = useState<any>(null);

    const {
        genderList,
        isGenderListLoaded,
        isGenderListLoading,
        relationshipList
    } = useSelector((state: IRootReducerState) => state.staticData);

    const navigateToAppointmentScreen = useCallback(() => {
        navigate(CommonService._routeConfig.DefaultRoute());
    }, [navigate]);

    const handleProviderDetailsModalClose = useCallback(() => {
        setIsProviderDetailsModalOpen(false);
        setInternalScreen("select-provider")
    }, []);

    const handlePaymentSuccessModalClose = useCallback(() => {
        setIsPaymentSuccessModalOpen(true);
    }, []);

    const handleAppointmentTimeUpModalClose = useCallback(() => {
        setIsAppointmentTimeUpModalOpen(true);
    }, []);

    const handleCategoryServiceModalClose = useCallback(() => {
        setIsCategoryServiceModalOpen(false)
    }, [])

    const handleOtpModalClose = useCallback(() => {
        setIsOtpModalOpen(false);
    }, []);

    const runOTPCountdown = useCallback(() => {
        setOtpTimer(OTP_VALIDITY);
        let timer = OTP_VALIDITY;
        // Clear any existing interval before starting a new one

        if (otpIntervalRef.current) {
            clearInterval(otpIntervalRef.current);
        }

        otpIntervalRef.current = setInterval(() => {
            timer--;
            setOtpTimer(timer);
            if (timer === 0) {
                clearInterval(otpIntervalRef.current!);
                otpIntervalRef.current = null;
            }
        }, 1000);
    }, []);

    const runCouponCountDown = useCallback(() => {
        setCouponTimer(COUPON_CODE_VALIDATOR);
        // Clear any existing interval before starting a new one
        if (couponIntervalRef.current) {
            clearInterval(couponIntervalRef.current);
        }

        couponIntervalRef.current = setInterval(() => {
            setCouponTimer((prevTimer: number) => {
                if (prevTimer === 0) {
                    clearInterval(couponIntervalRef.current!);
                    couponIntervalRef.current = null;
                    return null; // Set to null when it reaches zero
                }
                return prevTimer! - 1;
            });
        }, 1000);
    }, []);

    useEffect(() => {
        return () => {
            if (couponIntervalRef.current) {
                clearInterval(couponIntervalRef.current);
            }
        };
    }, []);

    const runFollowUpBookingCountDown = useCallback(() => {
        setRemainingTimeForFollowUpBooking(COUPON_CODE_VALIDATOR);

        // Clear any existing interval before starting a new one
        if (followUpIntervalRef.current) {
            clearInterval(followUpIntervalRef.current);
        }

        followUpIntervalRef.current = setInterval(() => {
            setRemainingTimeForFollowUpBooking((prevTime: number) => {
                if (prevTime === 0) {
                    clearInterval(followUpIntervalRef.current!);
                    followUpIntervalRef.current = null;
                    return null; // Set to null when the countdown ends
                }
                return prevTime! - 1;
            });
        }, 1000);
    }, []);

    useEffect(() => {
        return () => {
            if (followUpIntervalRef.current) {
                clearInterval(followUpIntervalRef.current);
            }
        };
    }, []);


    // Cleanup on unmount or when form closes
    useEffect(() => {
        return () => {
            if (otpIntervalRef.current) {
                clearInterval(otpIntervalRef.current);
            }
        };
    }, []);


    //Service List Api Call with selected Facility _id and Category _id
    const fetchFacilityAppointmentDetails = useCallback((categoryId: string) => {
        setIsServiceListLoading(true);
        let initialServiceList: any = [];
        CommonService._bookAppointment.GetServiceList(facilityDetails?._id, categoryId)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialServiceList = response.data;
                }
                setServiceList(initialServiceList);
                setIsServiceListLoading(false);
            }).catch((error: any) => {
            setServiceList(initialServiceList);
            setIsServiceListLoading(false);
        })
    }, [facilityDetails]);

    //linked provider list based on  Facility _id and Category _id
    const fetchLinkedProviderList = useCallback((categoryId: string) => {
        let initialProviderList: any = [];
        CommonService._bookAppointment.GetProvidersListBasedOnSelectedFacilityAndCategory(facilityDetails?._id, categoryId, {})
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderList = response.data;
                }
                setProviderListBasedOnCategoryFacilitySelected(initialProviderList);
            }).catch((error: any) => {
            setProviderListBasedOnCategoryFacilitySelected(initialProviderList);
        })
    }, [facilityDetails]);

    const fetchProviderAvailableDates = useCallback((providerId: any) => {
        setIsAvailableProviderDatesLoading(true);
        let initialProviderAvailableDates: any = [];
        let payload: any = {}
        payload.service_id = selectedServiceDetails?._id
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.facility_id = facilityDetails?._id;
        CommonService._bookAppointment.GetProviderAvailableDates(providerId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderAvailableDates = response.data;
                }
                setAvailableProviderDates(initialProviderAvailableDates);
                setIsAvailableProviderDatesLoading(false);
            }).catch((error: any) => {
            setAvailableProviderDates(initialProviderAvailableDates);
            setIsAvailableProviderDatesLoading(false);
        })
    }, [selectedServiceDetails, facilityDetails, selectedTimeDurationAndAmount]);

    const fetchProviderAvailableTimings = useCallback((availableDate: any) => {
        setIsAvailableProviderTimingsLoading(true);
        let initialProviderAvailableTimings: any = [];
        let payload: any = {}
        payload.service_id = selectedServiceDetails?._id
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.facility_id = facilityDetails?._id;
        payload.available_on = availableDate;

        CommonService._bookAppointment.GetProviderAvailableTimings(selectedProviderDetails?._id, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialProviderAvailableTimings = response.data;
                }
                setAvailableProviderTimings(initialProviderAvailableTimings);
                setIsAvailableProviderTimingsLoading(false);
            }).catch((error: any) => {
            setAvailableProviderTimings(initialProviderAvailableTimings);
            setIsAvailableProviderTimingsLoading(false);
        })
    }, [selectedServiceDetails, facilityDetails, selectedTimeDurationAndAmount, selectedProviderDetails]);

    const onOTPRequestSend = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        CommonService._account.RequestOTPAPICall(values)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setOTPFormInitialValues((prev: any) => {
                    return {...prev, ...values}
                });
                setIsOtpModalOpen(true);
                runOTPCountdown();
                setSubmitting(false);
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            });
    }, [runOTPCountdown]);

    const onLogin = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        CommonService._account.VerifyOTPAPICall(values)
            .then((response: IAPIResponseType<any>) => {
                // CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                dispatch(setLoggedInUserData(response?.data?.user));
                dispatch(setLoggedInUserToken(response?.data?.token));
                dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"))
                handleOtpModalClose();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
                handleOtpModalClose();
            })
    }, [dispatch, handleOtpModalClose]);

    const handleResendOTP = useCallback((values: any) => {
        setIsOTPBeingRequested(true);
        CommonService._account.RequestOTPAPICall(values)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                runOTPCountdown();
                setIsOTPBeingRequested(false);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error.error || 'Error sending OTP', "error");
                setIsOTPBeingRequested(false);
            })
    }, [runOTPCountdown]);

    const onNewClientRegister = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {...values};
        setSubmitting(true);
        payload['dob'] = CommonService.convertDateFormat(payload['dob']);
        CommonService._client.newClientRegister(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                setOTPFormInitialValues((prev: any) => {
                    return {...prev, ...values, username: values?.primary_email};
                });
                setIsOtpModalOpen(true);
                runOTPCountdown();
                setSubmitting(false);
            }).catch((error: any) => {
            CommonService.handleErrors(setErrors, error, true);
            setSubmitting(false)
        });
    }, [runOTPCountdown]);

    const ApplyCouponApiCall = useCallback(() => {
        setIsCouponCodeDataLoading(true)
        const payload: any = {};
        payload.coupon_code = checkOutCode;
        payload.service_id = selectedServiceDetails?._id;
        payload.amount = selectedTimeDurationAndAmount?.amount

        CommonService._bookAppointment.ApplyCouponAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setCouponCodeAppliedData(response?.data);
                setIsCouponCodeDataLoading(false);
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
            setIsCouponCodeDataLoading(false);
        });
    }, [checkOutCode, selectedServiceDetails, selectedTimeDurationAndAmount]);

    const onSomeOneElseSubmit = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {...values};
        setSubmitting(false)
        setIsNewClientAddingModalOpen(true)
        //  setSubmitting(true)
        payload['dob'] = CommonService.convertDateFormat(payload['dob']);
        setNewClientFormData({
            payload: payload,
            setSubmitting: setSubmitting,
            setErrors: setErrors,
        })
        // CommonService._client.ClientAddDetails(payload)
        //     .then((response: IAPIResponseType<IClientBasicDetails>) => {
        //         CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
        //         commonService._communications.TableWrapperRefreshSubject.next({
        //             moduleName: "accountsICanAccess"
        //         });
        //         setSubmitting(false);
        //         dispatch(getAccessibleAccounts());
        //         setInternalScreen("someone-else-screen")
        //     }).catch((error: any) => {
        //     CommonService.handleErrors(setErrors, error, true);
        //     setSubmitting(false)
        // });
    }, []);

    const BlockTheSlotApiCall = useCallback(() => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.provider_id = selectedProviderDetails?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        payload.appointment_date = selectedDate;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.start_time = selectedTime?.timeFrame?.start_time;
        payload.end_time = selectedTime?.timeFrame?.end_time;

        CommonService._bookAppointment.BlockTheSlotAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                setInternalScreen("checkout_page");
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                runCouponCountDown();
                setBlockSessionId(response?.data);
                let sessionIds: string[] = [];
                const storedSessionIds = CommonService._localStorage.getItem("block_session_id");
                if (storedSessionIds) {
                    try {
                        sessionIds = JSON.parse(storedSessionIds);
                        console.log(JSON.parse(storedSessionIds));
                    } catch (e) {
                        console.error("Failed to parse session IDs from localStorage", e);
                        sessionIds = [];
                    }
                }
                if (response?.data?.block_session_id) {
                    sessionIds.push(response.data.block_session_id);
                }
                CommonService._localStorage.setItem("block_session_id", JSON.stringify(sessionIds));
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
        });
    }, [runCouponCountDown, selectedDate, selectedProviderDetails, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedTime, selectedServiceDetails, selectedTimeDurationAndAmount]);
    const UnBlockTheFollowUpAppointmentApiCall = useCallback((appointmentDate: any, startTime: any, endTime: any, providerId: any) => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.provider_id = providerId;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        payload.appointment_date = appointmentDate;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.start_time = startTime;
        payload.end_time = endTime;
        payload.block_session_id = blockSessionId?.block_session_id;

        CommonService._bookAppointment.UnBlockTheSlotAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                fetchProviderAvailableTimings(appointmentDate);
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");

        });
    }, [fetchProviderAvailableTimings, blockSessionId, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedServiceDetails, selectedTimeDurationAndAmount]);
    const handleInitialFollowBookAppointment = useCallback((slot: { start_time: number; end_time: number }) => {
        if (!selectedDateForProviderFollowUp) return;
        console.log(rowId)
        if (rowId) {
            setAppointmentData((prevData: any) => ({
                ...prevData,
                sessions: prevData.sessions.map((session: any) =>
                    session.initial_id === rowId
                        ? {
                            ...session,
                            start_time: slot.start_time,
                            end_time: slot.end_time,
                        } // Update only this session
                        : session
                ),
            }));
            if (newlyAddedRowId) {
                setRowId(null)
            }
            if (previouslySelectedRow?.appointment_date && previouslySelectedRow?.start_time !== null && previouslySelectedRow?.end_time !== null && previouslySelectedRow?.provider_id) {
                UnBlockTheFollowUpAppointmentApiCall(previouslySelectedRow?.appointment_date, previouslySelectedRow?.start_time, previouslySelectedRow?.end_time, previouslySelectedRow?.provider_id)
            }

        } else if (!rowId && appointmentData?.sessions?.length === 0) {
            const newSession: any = {
                provider_id: selectedProviderDetails?._id,
                provider_details: selectedProviderDetails,
                appointment_date: selectedDateForProviderFollowUp,
                start_time: slot.start_time,
                end_time: slot.end_time,
                initial_id: CommonService.getUUID(),
                appointment_dateTime_utc: CommonService.convertDateToLocalTimeZone(
                    selectedDateForProviderFollowUp,
                    slot.start_time,
                    momentTimezone.tz.guess(),
                )
                //  appointment_dateTime_utc: utcDateTime.toISOString(),
            };

            setAppointmentData((prev: any) => ({
                ...prev,
                sessions: [...prev.sessions, newSession],
            }));
        }

    }, [newlyAddedRowId, previouslySelectedRow, UnBlockTheFollowUpAppointmentApiCall, selectedProviderDetails, selectedDateForProviderFollowUp, rowId, appointmentData]);
    const BlockTheFollowUpAppointmentSlotApiCall = useCallback((slot: any) => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.provider_id = selectedProviderDetails?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        payload.appointment_date = selectedDateForProviderFollowUp;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.start_time = slot?.start_time;
        payload.end_time = slot?.end_time;
        payload.hold_time_in_ms = remainingTimeForFollowUpBooking * 60000;

        if (rowId) {
            CommonService._bookAppointment.BlockTheSlotAPICall(payload)
                .then((response: IAPIResponseType<IClientBasicDetails>) => {
                    CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                    handleInitialFollowBookAppointment(slot)
                    setBlockSessionId(response?.data);
                    let sessionIds: string[] = [];
                    const storedSessionIds = CommonService._localStorage.getItem("block_session_id");
                    if (storedSessionIds) {
                        try {
                            sessionIds = JSON.parse(storedSessionIds);
                            console.log(JSON.parse(storedSessionIds));
                        } catch (e) {
                            console.error("Failed to parse session IDs from localStorage", e);
                            sessionIds = [];
                        }
                    }
                    if (response?.data?.block_session_id) {
                        sessionIds.push(response.data.block_session_id);
                    }
                    CommonService._localStorage.setItem("block_session_id", JSON.stringify(sessionIds));
                }).catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
            });
        } else if (!rowId && appointmentData?.sessions?.length === 0) {
            CommonService._bookAppointment.BlockTheSlotAPICall(payload)
                .then((response: IAPIResponseType<IClientBasicDetails>) => {
                    CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                    handleInitialFollowBookAppointment(slot)
                    setBlockSessionId(response?.data);
                    let sessionIds: any = CommonService._localStorage.getItem("block_session_id") || [];
                    if (response?.data?.block_session_id) {
                        sessionIds = [...sessionIds, response.data.block_session_id];
                    }
                    CommonService._localStorage.setItem("block_session_id", sessionIds);
                    if (appointmentData?.sessions?.length === 0) {
                        runFollowUpBookingCountDown();
                    }
                }).catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
            });
        } else if (!rowId && appointmentData?.sessions?.length > 0) {
            CommonService._alert.showToast("Click on Add Another Appointment Button or edit previously added appointment", "info")
        }
    }, [rowId, selectedDateForProviderFollowUp, handleInitialFollowBookAppointment, appointmentData, runFollowUpBookingCountDown, selectedProviderDetails, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedServiceDetails, selectedTimeDurationAndAmount, remainingTimeForFollowUpBooking]);
    const UnBlockTheSlotApiCall = useCallback(() => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.provider_id = selectedProviderDetails?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        payload.appointment_date = selectedDate;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.start_time = selectedTime?.timeFrame?.start_time;
        payload.end_time = selectedTime?.timeFrame?.end_time;
        payload.block_session_id = blockSessionId?.block_session_id;

        CommonService._bookAppointment.UnBlockTheSlotAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
        });
    }, [blockSessionId, selectedDate, selectedProviderDetails, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedTime, selectedServiceDetails, selectedTimeDurationAndAmount]);
    const BookAppointmentPaymentApiCall = useCallback((appointmentId: any) => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        if (selectedInjuryType === "initial_consultation") {
            payload.amount = Number(selectedTimeDurationAndAmount?.amount);
        } else if (selectedInjuryType === "followup_consultation") {
            payload.amount = Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length);
        }

        if (couponCodeAppliedData) {
            payload.coupon_code = checkOutCode
        }
        payload.payment_type = "current";
        payload.payment_mode = "credit_card";
        if (selectedInjuryType === "initial_consultation") {
            payload.appointment_ids = [appointmentId]
        } else if (selectedInjuryType === "followup_consultation") {
            payload.appointment_ids = appointmentId
        }

        payload.category_id = selectedCategoryDetails?._id;

        CommonService._bookAppointment.AppointmentPaymentAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setPaymentSuccessParentConfirmation(true);
                setIsPaymentSuccessModalOpen(true);
                setIsBookAppointmentFlowModalOpen(false);
                dispatch(setBookingAppointmentFlowNavigation(""))
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");

        });
    }, [setPaymentSuccessParentConfirmation, selectedInjuryType, appointmentData, setIsBookAppointmentFlowModalOpen, familyClientDetails, appointmentForType, checkOutCode, couponCodeAppliedData, currentUser, facilityDetails, selectedServiceDetails, selectedTimeDurationAndAmount, selectedCategoryDetails, dispatch]);
    const BookAppointmentApiCall = useCallback(() => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.provider_id = selectedProviderDetails?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        payload.appointment_date = selectedDate;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        payload.start_time = selectedTime?.timeFrame?.start_time;
        payload.end_time = selectedTime?.timeFrame?.end_time;
        payload.appointment_type = selectedInjuryType;
        if (couponCodeAppliedData?.discount_type === "percentage") {
            payload.amount = selectedTimeDurationAndAmount?.amount - CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount);
        }
        if (couponCodeAppliedData?.discount_type === "amount") {
            payload.amount = selectedTimeDurationAndAmount?.amount - couponCodeAppliedData?.amount;
        }
        if (!couponCodeAppliedData) {
            payload.amount = Number(selectedTimeDurationAndAmount?.amount);
        }
        payload.consultation_id = selectedTimeDurationAndAmount?.consultation_id;
        payload.appointment_dateTime_utc = CommonService.convertDateToLocalTimeZone(
            selectedDate,
            selectedTime?.timeFrame?.start_time,
            momentTimezone.tz.guess(),
        );

        CommonService._bookAppointment.BookAppointmentAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                BookAppointmentPaymentApiCall(response?.data?._id);
                setCouponTimer(null);
                CommonService._localStorage.removeItem("block_session_id");
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
            setInternalScreen("date_time_selection");
            setSelectedDate(null);
            setSelectedTime(null);
            setAvailableProviderTimings([]);
            setCouponTimer(null)
        });
    }, [BookAppointmentPaymentApiCall, couponCodeAppliedData, selectedInjuryType, selectedDate, selectedProviderDetails, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedTime, selectedServiceDetails, selectedTimeDurationAndAmount]);
    const BookFollowUpAppointmentApiCall = useCallback(() => {
        const payload: any = {};
        payload.client_id = appointmentForType === "my-self" ? (currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id) : familyClientDetails?.client_details?._id;
        payload.category_id = selectedCategoryDetails?._id;
        payload.facility_id = facilityDetails?._id;
        payload.service_id = selectedServiceDetails?._id;
        // payload.appointment_date = selectedDate;
        payload.duration = selectedTimeDurationAndAmount?.duration;
        // payload.start_time = selectedTime?.timeFrame?.start_time;
        // payload.end_time = selectedTime?.timeFrame?.end_time;
        payload.appointment_type = selectedInjuryType;
        payload.record_id = selectedCase?._id
        payload.sessions = appointmentData?.sessions.map(({initial_id, provider_details, ...rest}: any) => ({
            ...rest,
            appointment_dateTime_utc: CommonService.convertDateToLocalTimeZone(
                rest.appointment_date,
                rest?.start_time,
                momentTimezone.tz.guess(),
            ) // Replace with the actual key from `rest`
        }));

        if (couponCodeAppliedData?.discount_type === "percentage") {
            payload.amount = (selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length) - CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount);
        }
        if (couponCodeAppliedData?.discount_type === "amount") {
            payload.amount = (selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length) - couponCodeAppliedData?.amount;
        }
        if (!couponCodeAppliedData) {
            payload.amount = Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length);
        }
        payload.consultation_id = selectedTimeDurationAndAmount?.consultation_id;


        CommonService._bookAppointment.BookAppointmentAPICall(payload)
            .then((response: IAPIResponseType<IClientBasicDetails>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                BookAppointmentPaymentApiCall(response?.data)
                setRemainingTimeForFollowUpBooking(null)
                CommonService._localStorage.removeItem("block_session_id");
            }).catch((error: any) => {
            CommonService._alert.showToast(error[Misc.API_RESPONSE_ERROR_KEY], "error");
            setInternalScreen("date_time_selection");
            setSelectedDate(null);
            setSelectedTime(null);
            setAvailableProviderTimings([]);
            setRemainingTimeForFollowUpBooking(null)
        });
    }, [selectedCase, appointmentData, BookAppointmentPaymentApiCall, couponCodeAppliedData, selectedInjuryType, appointmentForType, currentUser, facilityDetails, familyClientDetails, selectedCategoryDetails, selectedServiceDetails, selectedTimeDurationAndAmount]);


    useEffect(() => {
        if (couponTimer === 0) {
            setIsAppointmentTimeUpModalOpen(true)
        }
    }, [couponTimer]);

    useEffect(() => {
        console.log(CommonService._localStorage.getItem("block_session_id"))
    }, []);

    useEffect(() => {
        if (remainingTimeForFollowUpBooking === 0) {
            setIsAppointmentTimeUpModalOpen(true)
        }
    }, [remainingTimeForFollowUpBooking]);

    const fetchCaseListLite = useCallback((clientId: any) => {
        setIsCaseListLoading(true);
        let initialCaseList: any = [];
        let payload: any = {}

        CommonService._bookAppointment.GetCaseListAPICall(clientId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    initialCaseList = response.data;
                }
                setCaseList(initialCaseList);
                setIsCaseListLoading(false);
            }).catch((error: any) => {
            setCaseList(initialCaseList);
            setIsCaseListLoading(false);
        })
    }, []);


    useEffect(() => {
        if (appointmentData?.sessions?.length === 0) {
            setRowId(null)
        }
    }, [appointmentData]);


    const bookedSlots = appointmentData?.sessions?.filter(
        (session: any) =>
            session.provider_id === selectedProviderDetails?._id &&
            session.appointment_date === selectedDateForProviderFollowUp
    );


    const handleRemoveSession = useCallback((sessionDetails: any) => {
        setAppointmentData((prevData: any) => ({
            ...prevData,
            sessions: prevData.sessions.filter(
                (session: any) =>
                    session.provider_id !== sessionDetails?.provider_id ||
                    session.start_time !== sessionDetails?.start_time ||
                    session.appointment_date !== sessionDetails?.appointment_date
            ),
        }));
    }, []);

    useEffect(() => {
        if (selectedDateForProviderFollowUp) {
            fetchProviderAvailableTimings(selectedDateForProviderFollowUp)
        }
    }, [selectedDateForProviderFollowUp, fetchProviderAvailableTimings]);


    return (
        <div className={'book-appointment-flow-modal'}>
            <ConfirmationModal
                isOpen={isNewClientAddingModalOpen}
                onClose={() => setIsNewClientAddingModalOpen(false)}
                onConfirm={() => {
                    setIsNewClientAddingModalOpen(false);
                    CommonService._client.ClientAddDetails(newClientFormData?.payload)
                        .then((response: IAPIResponseType<IClientBasicDetails>) => {
                            CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                            commonService._communications.TableWrapperRefreshSubject.next({
                                moduleName: "accountsICanAccess"
                            });
                            newClientFormData?.setSubmitting(false);
                            dispatch(getAccessibleAccounts());
                            setInternalScreen("someone-else-screen")
                        }).catch((error: any) => {
                        CommonService.handleErrors(newClientFormData?.setErrors, error, true);
                        newClientFormData?.setSubmitting(false)
                    });
                }}
                confirmText="Proceed"
                confirmationMessage={<div>
                    <div className={'mrg-bottom-20'}>
                        By creating this new account, you are agreeing to link both<br/>
                        accounts together.
                    </div>
                    <div className={'mrg-bottom-20'}>
                        Please note that this means:
                    </div>
                    <div className={'mrg-bottom-20'}>
                        &nbsp; &nbsp;<span className={'text-bold-high-lighter'}>. You</span> can access their account to
                        book
                        appointments <br/>&nbsp; &nbsp;&nbsp;&nbsp;and
                        manage it for them.
                    </div>
                    <div className={'mrg-bottom-20'}>
                        &nbsp;&nbsp; <span className={'text-bold-high-lighter'}>. They</span> can access your account to
                        book
                        appointments <br/>&nbsp; &nbsp;&nbsp;&nbsp;and
                        manage it for you.
                    </div>
                    <div>
                        &nbsp;&nbsp; <span className={'text-bold-high-lighter'}>. Both </span>account holders can modify
                        or revoke access at
                        any <br/>&nbsp; &nbsp;&nbsp;&nbsp;time by visiting the
                        <span className={'text-bold-high-lighter'}> Link/Unlink Profile </span>

                        section of their<br/>&nbsp; &nbsp;&nbsp; accounts.
                    </div>
                </div>}
            />
            <ConfirmationModal
                isOpen={isBookingUnblockedConfirmationModalOpen}
                onClose={() => setIsBookingUnblockedConfirmationModalOpen(false)}
                onConfirm={() => {
                    UnBlockTheSlotApiCall();
                    setIsBookingUnblockedConfirmationModalOpen(false);
                    setSelectedTime(null);
                    setSelectedDate(null);
                    setAvailableProviderTimings([]);
                    setInternalScreen("date_time_selection");
                }}
                confirmText="Proceed"
                confirmationMessage={<div className={'center-align-text'}>Are you sure you want to go back? If so,
                    your<br/> selected appointment slot
                    will
                    be released,<br/> allowing others to book it.</div>}
            />
            <ConfirmationModal
                isOpen={isCheckoutConfirmationModalOpen}
                onClose={() => setIsCheckoutConfirmationModalOpen(false)}
                onConfirm={() => {
                    setIsCheckoutConfirmationModalOpen(false);

                    if (selectedInjuryType === "initial_consultation") {
                        BookAppointmentApiCall();
                        setCouponTimer(null)
                    } else if (selectedInjuryType === "followup_consultation") {
                        BookFollowUpAppointmentApiCall()
                        setRemainingTimeForFollowUpBooking(null)
                    }
                }}
                confirmText="Check Out"
                confirmationMessage={<div className={'center-align-text'}>Are you sure you want to checkout? If
                    so,<br/> your selected appointment will be booked.</div>}
            />

            <ConfirmationModal
                closeButtonRequired={false}
                isOpen={isContactUsConfirmationModalOpen}
                onClose={() => setIsContactUsConfirmationModalOpen(false)}
                onConfirm={() => {
                    setIsContactUsConfirmationModalOpen(false)
                }}
                confirmText="Close"
                confirmationMessage={<div className={'center-align-text'}>
                    <span
                        className={'appointment-followup-contactus-text'}> Kinergy Sports and Medicine - Strip</span><br/>
                    Phone Number: (322) 321-3213
                </div>}
            />
            {/*Category Service Details Modal*/}
            <ModalComponent
                isOpen={isCategoryServiceModalOpen}
                onClose={handleCategoryServiceModalClose}
            >
                <CategoryServiceDetailsComponent handleCategoryServiceModalClose={handleCategoryServiceModalClose}
                                                 selectedServiceDetails={selectedServiceDetails}
                                                 selectedCategoryDetails={selectedCategoryDetails}/>
            </ModalComponent>
            {/*PAYMENT SUCCESS AND APPOINTMENT BOOKED SUCCESS POPUP*/}
            <ModalComponent
                isOpen={isPaymentSuccessModalOpen}
                onClose={handlePaymentSuccessModalClose}
            >
                <div
                    className="payment-success-modal d-flex justify-content-center align-items-center pdd-top-40 pdd-bottom-40">
                    <div>
                        <div className={'d-flex justify-content-center align-items-center'}>
                            <img width={100} height={100} src={ImageConfig.PaymentSuccessIcon}
                                 alt={'payment_success_icon'}/>
                        </div>

                        <div className={'amount-text d-flex justify-content-center align-items-center mrg-top-20'}>$
                            {(selectedInjuryType === "initial_consultation" && !couponCodeAppliedData) &&
                                <span>
                                                    {Number(selectedTimeDurationAndAmount?.amount).toFixed(2)}
                                                </span>}
                            {(selectedInjuryType === "initial_consultation" && couponCodeAppliedData) &&
                                <span>
                                                    {Number(Number(selectedTimeDurationAndAmount?.amount) - (couponCodeAppliedData?.discount_type === "percentage" ? CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount) : couponCodeAppliedData?.amount)).toFixed(2)}
                                                </span>}
                            {(selectedInjuryType === "followup_consultation" && !couponCodeAppliedData) &&
                                <span>
                                                    {Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length).toFixed(2)}
                                                </span>}
                            {(selectedInjuryType === "followup_consultation" && couponCodeAppliedData) &&
                                <span>
                                                    {Number(Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length) - (couponCodeAppliedData?.discount_type === "percentage" ? CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount) : couponCodeAppliedData?.amount)).toFixed(2)}
                                                </span>}
                        </div>
                        <div className={'amount-text d-flex justify-content-center align-items-center mrg-top-5'}>
                            Payment Success!
                        </div>
                        <div
                            className={'welcoming-note-text d-flex justify-content-center align-items-center mrg-top-20'}>
                            Thank you for booking with us!
                        </div>
                        <div
                            className={'appointment-details-text  mrg-top-30'}>
                            Your appointment has been scheduled at <span
                            className={'facility-name-text'}>&nbsp;{facilityDetails?.name}&nbsp;</span> for:
                        </div>
                        {selectedInjuryType === "initial_consultation" &&
                            <div className={'d-flex justify-content-space-between align-items-center mrg-top-25'}>
                                <div>
                                    <div className={'d-flex'}>
                                        <div><ImageConfig.ProfileFacilityIcon/></div>
                                        <div className={'info-text d-flex ts-align-items-center mrg-left-5'}>
                                            {selectedProviderDetails?.first_name}&nbsp;{selectedProviderDetails?.last_name}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className={'d-flex'}>
                                        <div><ImageConfig.CalenderIconAppointment/></div>
                                        <div className={'info-text d-flex ts-align-items-center mrg-left-5'}>
                                            {CommonService.getSystemFormatTimeStamp(selectedDate)}
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className={'d-flex'}>
                                        <div><ImageConfig.WatchTimer color={"#83909D"} width={24} height={24}/></div>
                                        <div
                                            className={'info-text d-flex ts-align-items-center mrg-left-5'}>{CommonService.getHoursAndMinutesFromMinutes(selectedTime?.timeFrame?.start_time)}</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {selectedInjuryType === "followup_consultation" &&
                            <div>
                                {appointmentData?.sessions?.map((session: any, index: any) => {
                                    return (
                                        <div className={"mrg-bottom-10"} key={index}>
                                            <div
                                                className={'d-flex justify-content-space-between align-items-center mrg-top-25'}>
                                                <div>
                                                    <div className={'d-flex'}>
                                                        <div><ImageConfig.ProfileFacilityIcon/></div>
                                                        <div
                                                            className={'info-text d-flex ts-align-items-center mrg-left-5'}>
                                                            {session?.provider_details?.first_name}&nbsp;{session?.provider_details?.last_name}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className={'d-flex'}>
                                                        <div><ImageConfig.CalenderIconAppointment/></div>
                                                        <div
                                                            className={'info-text d-flex ts-align-items-center mrg-left-5'}>
                                                            {CommonService.getSystemFormatTimeStamp(session?.appointment_date)}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className={'d-flex'}>
                                                        <div><ImageConfig.WatchTimer color={"#83909D"} width={24}
                                                                                     height={24}/></div>
                                                        <div
                                                            className={'info-text d-flex ts-align-items-center mrg-left-5'}>{CommonService.getHoursAndMinutesFromMinutes(session?.start_time)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        <div className={'d-flex justify-content-center align-items-center mrg-top-30'}>
                            <ButtonComponent
                                disabled={!isAttendancePolicyChecked}
                                className={'mrg-top-40'}
                                onClick={() => {
                                    navigateToAppointmentScreen();
                                    dispatch(setBookingAppointmentFlowNavigation("category_selection_screen"))
                                }}
                                //   onClick={handleSecureCheckout}
                                //  isLoading={isCheckingOutInProgress}
                            >
                                Proceed to Dashboard
                            </ButtonComponent>
                        </div>
                    </div>

                </div>
            </ModalComponent>
            {/*Time Up Warning Popup*/}
            <ModalComponent
                isOpen={isAppointmentTimeUpModalOpen}
                onClose={handleAppointmentTimeUpModalClose}
            >
                <div
                    className="time-up-modal d-flex justify-content-center align-items-center pdd-top-40 pdd-bottom-40">
                    <div>
                        <div className={'d-flex justify-content-center align-items-center'}>
                            <img width={107} height={93} src={ImageConfig.TimeUpIcon}
                                 alt={'payment_success_icon'}/>
                        </div>
                        <div className={'regret-text d-flex justify-content-center align-items-center mrg-top-5'}>
                            Sorry...Time's Up!
                        </div>
                        <div
                            className={'time-up-notice-text d-flex justify-content-center  align-items-center mrg-top-20'}>
                            The time limit to complete your booking has<br/>
                            expired. Please select a new date and time<br/>
                            for your appointment.
                        </div>
                        <div className={'d-flex justify-content-center align-items-center mrg-top-30'}>
                            <ButtonComponent
                                className={''}
                                onClick={() => {
                                    if (selectedInjuryType === "initial_consultation") {
                                        setInternalScreen("date_time_selection");
                                        setSelectedTime(null);
                                        setSelectedDate(null);
                                        setAvailableProviderTimings([]);
                                        setIsAppointmentTimeUpModalOpen(false)
                                    } else if (selectedInjuryType === "followup_consultation") {
                                        setSelectedProviderDetails(null)
                                        setSelectedDateForProviderFollowUp(null)
                                        setAvailableProviderTimings([])
                                        dispatch(setBookingAppointmentFlowNavigation("followup-appointment-booking-screen"))
                                        setIsAppointmentTimeUpModalOpen(false)
                                        setAppointmentData({
                                            client_id: "",
                                            category_id: "",
                                            service_id: "",
                                            facility_id: "",
                                            appointment_type: "followup_consultation",
                                            consultation_id: "",
                                            record_id: "",
                                            duration: 0,
                                            amount: 0,
                                            sessions: [],
                                        })
                                    }
                                }}
                            >
                                Select New Date & Time
                            </ButtonComponent>
                        </div>
                    </div>

                </div>
            </ModalComponent>


            <ModalComponent
                isOpen={isProviderDetailsModalOpen}
                onClose={handleProviderDetailsModalClose}
            >
                <div
                    className="book-appointment-modal-container d-flex justify-content-center align-items-center">
                    <ProviderDetailsModalComponent
                        setInternalScreen={setInternalScreen}
                        setIsProviderDetailsModalOpen={setIsProviderDetailsModalOpen}
                        providerDetails={providerDetails}
                        isProviderDetailsLoading={isProviderDetailsLoading}

                    />
                </div>
            </ModalComponent>
            <ModalComponent
                isOpen={isOtpModalOpen}
                onClose={handleOtpModalClose}
            >
                <div
                    className="otp-modal-container">
                    <div
                        className={'mrg-bottom-25 mrg-top-25 mrg-right-25 d-flex ts-justify-content-end cursor-pointer'}
                        onClick={() => {
                            handleOtpModalClose();
                        }}>
                        <ImageConfig.CloseIcon color={"#1479FF"}/></div>
                    <div className={'d-flex justify-content-center align-items-center'}>
                        <Formik
                            validationSchema={otpFormValidationSchema}
                            initialValues={otpFormInitialValues}
                            validateOnChange={false}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            validateOnMount={true}
                            onSubmit={onLogin}
                        >
                            {(formik) => {
                                const {values, validateForm, isValid, isSubmitting: isLoggingIn} = formik;
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                useEffect(() => {
                                    validateForm();
                                }, [validateForm, values]);
                                return (
                                    <Form className="" noValidate={true}>
                                        <div className="">
                                            <div className="">
                                                <div className={'d-flex justify-content-center mrg-bottom-25'}>
                                                    <ImageConfig.OTPPhoneIcon/>
                                                </div>
                                                <div>
                                                    <div>
                                                        <div className={'security-code-header mrg-bottom-10'}
                                                             onClick={() => {
                                                                 console.log(values)
                                                             }}>
                                                            Security Code Verification
                                                        </div>
                                                        <div className={'security-code-text mrg-bottom-25'}>
                                                            Please enter the One-Time Password (OTP) we sent to
                                                            example@email.com
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="book-appointment-otp-component">
                                                    <div className={'d-flex justify-content-center'}>
                                                        <Field name={'otp'} className="t-form-control">
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikOTPComponent
                                                                        placeholder={'000000'}
                                                                        required={true}
                                                                        formikField={field}
                                                                        fullWidth={false}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                    </div>
                                                    <div className="appointment-otp-form__body__controls__resend_otp">
                                                        {
                                                            otpTimer > 0 ?
                                                                <LinkComponent disabled={true}
                                                                               className={'text-decoration-none timer mrg-top-18'}>
                                                                    {CommonService.getMinsAndSecondsFromSeconds(otpTimer).minutes + " : " + CommonService.getMinsAndSecondsFromSeconds(otpTimer).seconds}
                                                                </LinkComponent>
                                                                :
                                                                <LinkComponent
                                                                    onClick={() => handleResendOTP(values)}
                                                                    disabled={isOTPBeingRequested}
                                                                    className={'mrg-top-18 timer-text'}
                                                                >
                                                                    {isOTPBeingRequested ? "Sending OTP" : "Resend OTP"}
                                                                </LinkComponent>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="login-form__body__controls__button mrg-top-70">
                                                    <ButtonComponent
                                                        id={'submit_btn'}
                                                        type={"submit"}
                                                        fullWidth={true}
                                                        disabled={!isValid || isLoggingIn}
                                                    >
                                                        Submit
                                                    </ButtonComponent>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </div>
                </div>
            </ModalComponent>
            <div className={'modal-wrapper'}>
                <ModalComponent isOpen={isAttendanceModalOpen}
                                closeOnBackDropClick={true}
                                onClose={() => setIsAttendanceModalOpen(false)}
                >
                    <AttendanceAndCancellationPolicyComponent setIsAttendanceModalOpen={setIsAttendanceModalOpen}/>
                </ModalComponent>
            </div>
            {/*Category Selection Screen*/}
            {currentBookingAppointmentFlowNavigation === "category_selection_screen" &&
                <div className={'pdd-left-25 pdd-right-25 pdd-top-25'}>
                    <div className={'previous-button d-flex mrg-bottom-40'}>
                        <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                             onClick={() => {
                                 setIsBookAppointmentFlowModalOpen(false);
                             }}>
                            <ImageConfig.LeftArrow color={"#66FFE0"}/>
                        </div>
                        <div
                            className={'back-text-orientation d-flex ts-justify-content-center align-items-center'}>
                            Previous
                        </div>
                    </div>
                    <div className={'book-appointment-flow-content-wrapper d-flex'}>
                        <div className={'flex-2 d-flex align-items-center'}>
                            <div className={'flex-1 d-flex flex-direction-column mrg-left-15'}>
                                <div className={'branding-text '}>
                                    What are you<br/>
                                    here for today?
                                </div>
                                <div className={'branding-minor-text mrg-top-10'}>
                                    Please select a service category from the list.
                                </div>
                            </div>
                        </div>
                        <div className="book-appointment-flow-category-container flex-3">
                            <Row gutter={[16, 16]}>
                                {serviceCategoryDetails && serviceCategoryDetails?.map((category: any) => (
                                    <Col xs={30} sm={16} md={10} lg={8} key={category._id}>
                                        <div className={'service-holder'} onClick={() => {
                                            setSelectedCategoryDetails(category);
                                            fetchFacilityAppointmentDetails(category?._id);
                                            dispatch(setBookingAppointmentFlowNavigation("category_service_selection_screen"));
                                        }}>
                                            <div className={'service-image-holder'}>
                                                <img
                                                    alt={category?.name}
                                                    src={category?.image?.url}
                                                />
                                            </div>
                                            <div
                                                className={`service-category-name-holder ${category?._id === selectedCategoryDetails?._id ? "active" : "non-active"} d-flex justify-content-space-between align-items-center`}>
                                                <div className={'category-name-text'}> {category.name}</div>
                                                <div className={'mrg-left-30'}><ImageConfig.ServiceCardNavigatorIcon
                                                    color={category?._id === selectedCategoryDetails?._id ? "#1479FF" : "#66FFE0"}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                </div>
            }
            {/*Category Service Selection*/}
            {currentBookingAppointmentFlowNavigation === "category_service_selection_screen" &&
                <div className={'pdd-left-25 pdd-right-25 pdd-top-25'}>
                    <div className={'previous-button d-flex mrg-bottom-40'}>
                        <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                             onClick={() => {
                                 dispatch(setBookingAppointmentFlowNavigation("category_selection_screen"));
                             }}>
                            <ImageConfig.LeftArrow color={"#66FFE0"}/>
                        </div>
                        <div
                            className={'back-text-orientation d-flex ts-justify-content-center align-items-center'}>
                            Previous
                        </div>
                    </div>
                    <div className={'book-appointment-flow-content-wrapper d-flex'}>
                        <div className={'flex-2'}>
                            <div className={'category-details-holder_book_appointment_flow d-flex mrg-left-20'}>
                                <div className={'active-status-show-on-card'}></div>
                                <div className={'pdd-20'}>
                                    <div className={'d-flex'}>
                                        <div>
                                            <img className={'details-image'} src={selectedCategoryDetails?.image?.url}
                                                 width={48} height={32}
                                                 alt={selectedCategoryDetails?.name}/>
                                        </div>
                                        <div className={'category-details-text-wrapper mrg-left-20'}>
                                            <div
                                                className={'category-name-text-in-details mrg-bottom-5'}>{selectedCategoryDetails?.name}</div>
                                            <div>
                                                <Paragraph className={'category-description-wrapper'}
                                                           ellipsis={{rows: 2, expandable: false}}>
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: selectedCategoryDetails?.description}}/>
                                                </Paragraph>
                                                <div className={"appointment-blue-text"} onClick={() => {
                                                    setIsCategoryServiceModalOpen(true)
                                                }}>
                                                    Read More
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'mrg-top-50'}>
                                <div className={'d-flex flex-direction-column mrg-left-15'}>
                                    <div className={'branding-text'}>
                                        Ok. What are you <br/>
                                        interested in?
                                    </div>
                                    <div className={'branding-minor-text mrg-top-10'}>
                                        Please select a service from the list.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="book-appointment-flow-service-container flex-3">
                            <div className={'d-flex justify-content-center align-items-center'}>
                                {isServiceListLoading &&
                                    <div>
                                        <LoaderComponent type={"spinner"} color={'success'}/>
                                    </div>
                                }
                            </div>
                            {!isServiceListLoading &&
                                <div className="services-grid mrg-left-55">
                                    {serviceList?.map((service: any) => (
                                        <div>
                                            <div
                                                className={`service-card ${service?._id === selectedServiceDetails?._id ? "service-active" : "service-not-active"}`}
                                                key={service?._id} onClick={() => {
                                                fetchLinkedProviderList(service?._id);
                                                setSelectedServiceDetails(service)
                                                dispatch(setBookingAppointmentFlowNavigation("injury_type_selection_screen"));
                                            }}>
                                                <div className={'d-flex  align-items-center'}>
                                                    <img src={service?.image?.url} alt={service?.name} width={112}
                                                         height={76}
                                                         className="service-image"/>
                                                    <div className="service-name mrg-left-10">{service?.name}</div>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>}
                        </div>
                    </div>
                </div>
            }
            {/*Injury Type Selection component*/}
            {
                currentBookingAppointmentFlowNavigation === "injury_type_selection_screen" &&
                <div className={'pdd-left-25 pdd-right-25 pdd-top-25'}>
                    <div className={'previous-button d-flex mrg-bottom-40'}>
                        <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                             onClick={() => {
                                 dispatch(setBookingAppointmentFlowNavigation("category_service_selection_screen"));
                             }}>
                            <ImageConfig.LeftArrow color={"#66FFE0"}/>
                        </div>
                        <div
                            className={'back-text-orientation d-flex ts-justify-content-center align-items-center'}>
                            Previous
                        </div>
                    </div>
                    <div className={'book-appointment-flow-content-wrapper d-flex'}>
                        <div className={'flex-2'}>
                            <div className={'category-details-holder_book_appointment_flow d-flex mrg-left-20'}>
                                <div className={'active-status-show-on-card'}></div>
                                <div className={'pdd-20'}>
                                    <div className={'d-flex'}>
                                        <div>
                                            <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                                 width={48} height={32}
                                                 alt={selectedServiceDetails?.name}/>
                                        </div>
                                        <div className={'category-details-text-wrapper mrg-left-20'}>
                                            <div
                                                className={'category-sub-name-text-in-details'}>{selectedCategoryDetails?.name}</div>
                                            <div
                                                className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>
                                            <div>
                                                <Paragraph className={'category-description-wrapper'}
                                                           ellipsis={{rows: 2, expandable: false}}>
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                                                </Paragraph>
                                                <div className={"appointment-blue-text"} onClick={() => {
                                                    setIsCategoryServiceModalOpen(true)
                                                }}>
                                                    Read More
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'mrg-top-50'}>
                                <div className={'d-flex flex-direction-column mrg-left-15'}>
                                    <div className={'branding-text'}>
                                        Is this for a new or<br/>
                                        an existing problem?
                                    </div>
                                    <div className={'branding-minor-text mrg-top-10'}>
                                        Please select one of the options.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="book-appointment-flow-injury-type-container flex-3  d-flex justify-content-center">
                            <div>
                                <div
                                    className={`injury-type-container mrg-bottom-20 ${selectedInjuryType === "initial_consultation" ? "injury-type-active" : "injury-type-non-active"}`}>
                                    <div className={'injury-type-header'}>
                                        New Injury/Condition
                                    </div>
                                    <div className={'injury-type-text mrg-top-25 mrg-bottom-25'}>
                                        Book your <span className={'specific-text'}>FIRST</span> Appointment
                                    </div>
                                    <div className={'injury-type-button d-flex justify-content-center'}>
                                        <ButtonComponent onClick={() => {
                                            setSelectedInjuryType("initial_consultation");
                                            dispatch(setBookingAppointmentFlowNavigation("time_rate_slot_selection_screen"));
                                        }}>
                                            Select
                                        </ButtonComponent>
                                    </div>
                                </div>

                                <div
                                    className={`injury-type-container mrg-bottom-20 ${selectedInjuryType === "followup_consultation" ? "injury-type-active" : "injury-type-non-active"}`}>
                                    <div className={'injury-type-header'}>
                                        Existing Injury/Condition
                                    </div>
                                    <div className={'injury-type-text mrg-top-25 mrg-bottom-25'}>
                                        Book your <span className={'specific-text'}>FOLLOW-UP</span> Appointment
                                    </div>
                                    <div className={'injury-type-button d-flex justify-content-center'}>
                                        <ButtonComponent onClick={() => {
                                            setSelectedProviderDetails(null)
                                            setSelectedInjuryType("followup_consultation");
                                            dispatch(setBookingAppointmentFlowNavigation("time_rate_slot_selection_screen"));
                                        }}>
                                            Select
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {/*Time Frame and Rate Selection Screen*/}
            {
                currentBookingAppointmentFlowNavigation === "time_rate_slot_selection_screen" &&
                <div className={'pdd-left-25 pdd-right-25 pdd-top-25'}>
                    <div className={'previous-button d-flex mrg-bottom-40'}>
                        <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                             onClick={() => {
                                 dispatch(setBookingAppointmentFlowNavigation("injury_type_selection_screen"));
                             }}>
                            <ImageConfig.LeftArrow color={"#66FFE0"}/>
                        </div>
                        <div
                            className={'back-text-orientation d-flex ts-justify-content-center align-items-center'}>
                            Previous
                        </div>
                    </div>
                    <div className={'book-appointment-flow-content-wrapper d-flex'}>
                        <div className={'flex-2'}>
                            <div className={'category-details-holder_book_appointment_flow d-flex mrg-left-20'}>
                                <div className={'active-status-show-on-card'}></div>
                                <div className={'pdd-20'}>
                                    <div className={'d-flex'}>
                                        <div>
                                            <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                                 width={30} height={22}
                                                 alt={selectedServiceDetails?.name}/>
                                        </div>
                                        <div className={'category-details-text-wrapper mrg-left-20'}>
                                            <div
                                                className={'category-sub-name-text-in-details'}>{selectedCategoryDetails?.name}</div>
                                            <div
                                                className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>
                                            <div>
                                                <Paragraph className={'category-description-wrapper'}
                                                           ellipsis={{rows: 2, expandable: false}}>
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                                                </Paragraph>
                                                <div className={"appointment-blue-text"} onClick={() => {
                                                    setIsCategoryServiceModalOpen(true)
                                                }}>
                                                    Read More
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'mrg-top-50'}>
                                <div className={'d-flex flex-direction-column mrg-left-15'}>
                                    <div className={'branding-text'}>
                                        How much time <br/>
                                        would you like?
                                    </div>
                                    <div className={'branding-minor-text mrg-top-10'}>
                                        Please select one of the options.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="book-appointment-flow-time-rate-container flex-3">
                            {
                                selectedInjuryType === "initial_consultation" && <div>
                                    {
                                        selectedServiceDetails && selectedServiceDetails?.initial_consultation?.map((timeSlot: any) => {
                                            return (
                                                <div>
                                                    {timeSlot?.consultation_details?.map((consultationDetails: any, index: number) => {
                                                        return (

                                                            <div key={timeSlot?.id + index}
                                                                 className={`${(selectedTimeDurationAndAmount?.duration === consultationDetails?.duration && timeSlot?.id === selectedTimeDurationAndAmount?.consultation_id) ? "time-slot-rate-active" : "time-slot-rate-not-active"} cursor-pointer time-slot-rate-wrapper margin-left-185 pdd-25 mrg-right-20 d-flex justify-content-space-between align-items-center mrg-bottom-10`}
                                                                 onClick={() => {
                                                                     setSelectedTimeDurationAndAmount({
                                                                         ...selectedTimeDurationAndAmount,
                                                                         consultation_id: timeSlot?.id,
                                                                         duration: consultationDetails?.duration,
                                                                         amount: consultationDetails?.price,
                                                                     });
                                                                     dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"))
                                                                     // dispatch(setBookingAppointmentFlowNavigation("client_type_selection"));
                                                                 }}>
                                                                <div>
                                                                    <div
                                                                        className={'service-title-text'}>{timeSlot?.title} </div>
                                                                    <div className={'service-duration-amount-text'}>
                                                                        {consultationDetails?.duration - Number(selectedServiceDetails?.buffer_time)} mins
                                                                        |
                                                                        ${Number(consultationDetails?.price).toFixed(2)}
                                                                    </div>
                                                                </div>
                                                                <ImageConfig.ServiceCardNavigatorIcon
                                                                    color={"#66FFE0"}/>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                            {
                                selectedInjuryType === "followup_consultation" && <div>
                                    {
                                        selectedServiceDetails && selectedServiceDetails?.followup_consultation?.map((timeSlot: any) => {
                                            return (
                                                <div>
                                                    {timeSlot?.consultation_details?.map((consultationDetails: any, index: number) => {
                                                        return (

                                                            <div key={timeSlot?.id + index}
                                                                 className={`${(selectedTimeDurationAndAmount?.duration === consultationDetails?.duration && timeSlot?.id === selectedTimeDurationAndAmount?.consultation_id) ? "time-slot-rate-active" : "time-slot-rate-not-active"} cursor-pointer time-slot-rate-wrapper margin-left-185 pdd-25 mrg-right-20 d-flex justify-content-space-between align-items-center mrg-bottom-10`}
                                                                 onClick={() => {
                                                                     setSelectedTimeDurationAndAmount({
                                                                         ...selectedTimeDurationAndAmount,
                                                                         consultation_id: timeSlot?.id,
                                                                         duration: consultationDetails?.duration,
                                                                         amount: consultationDetails?.price,
                                                                     });
                                                                     // dispatch(setBookingAppointmentFlowNavigation("client_type_selection"));
                                                                     dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"))
                                                                 }}>
                                                                <div>
                                                                    <div
                                                                        className={'service-title-text'}>{timeSlot?.title} </div>
                                                                    <div className={'service-duration-amount-text'}>
                                                                        {consultationDetails?.duration - Number(selectedServiceDetails?.buffer_time)} mins
                                                                        |
                                                                        ${Number(consultationDetails?.price).toFixed(2)}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <ImageConfig.ServiceCardNavigatorIcon
                                                                        color={"#66FFE0"}/>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            {/*Client Type Selection*/}
            {/*{*/}
            {/*    currentBookingAppointmentFlowNavigation === "client_type_selection" &&*/}
            {/*    <div className={'pdd-left-25 pdd-right-25 pdd-top-25'}>*/}
            {/*        <div className={'previous-button d-flex mrg-bottom-40'}>*/}
            {/*            <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}*/}
            {/*                 onClick={() => {*/}
            {/*                     dispatch(setBookingAppointmentFlowNavigation("time_rate_slot_selection_screen"));*/}
            {/*                 }}>*/}
            {/*                <ImageConfig.LeftArrow color={"#66FFE0"}/>*/}
            {/*            </div>*/}
            {/*            <div*/}
            {/*                className={'back-text-orientation d-flex ts-justify-content-center align-items-center'}>*/}
            {/*                Previous*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div className={'book-appointment-flow-content-wrapper d-flex'}>*/}
            {/*            <div className={'flex-2'}>*/}
            {/*                <div className={'category-details-holder_book_appointment_flow d-flex mrg-left-20'}>*/}
            {/*                    <div className={'active-status-show-on-card'}></div>*/}
            {/*                    <div className={'pdd-20'}>*/}
            {/*                        <div className={'d-flex'}>*/}
            {/*                            <div>*/}
            {/*                                <img className={'details-image'} src={selectedServiceDetails?.image?.url}*/}
            {/*                                     width={30} height={22}*/}
            {/*                                     alt={selectedServiceDetails?.name}/>*/}
            {/*                            </div>*/}
            {/*                            <div className={'category-details-text-wrapper mrg-left-20'}>*/}
            {/*                                <div*/}
            {/*                                    className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>*/}
            {/*                                <div>*/}
            {/*                                    <Paragraph className={'category-description-wrapper'}*/}
            {/*                                               ellipsis={{rows: 2, expandable: false}}>*/}
            {/*                                        <div*/}
            {/*                                            dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>*/}
            {/*                                    </Paragraph>*/}
            {/*                                    <div className={"appointment-blue-text"} onClick={() => {*/}
            {/*                                        setIsCategoryServiceModalOpen(true)*/}
            {/*                                    }}>*/}
            {/*                                        Read More*/}
            {/*                                    </div>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className={'mrg-top-50'}>*/}
            {/*                    <div className={'d-flex flex-direction-column mrg-left-15'}>*/}
            {/*                        <div className={'branding-text'}>*/}
            {/*                            Are you a new or <br/>*/}
            {/*                            returning client?*/}
            {/*                        </div>*/}
            {/*                        <div className={'branding-minor-text mrg-top-10'}>*/}
            {/*                            Please select one of the options.*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div*/}
            {/*                className="book-appointment-flow-client-type-container flex-3">*/}
            {/*                {!token &&*/}
            {/*                    <div*/}
            {/*                        className={`${clientNewReturningType === "new_client" ? "client-type-active" : "client-type-not-active"} cursor-pointer client-type-wrapper mrg-left-100 pdd-25 d-flex justify-content-space-between align-items-center mrg-bottom-20`}*/}
            {/*                        onClick={() => {*/}
            {/*                            setClientNewReturningType("new_client");*/}
            {/*                            if (!token) {*/}
            {/*                                dispatch(setBookingAppointmentFlowNavigation("client_form_based_client_type_selection_screen"))*/}
            {/*                            } else {*/}
            {/*                                dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"))*/}
            {/*                            }*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        <div className={'client-type-text'}>*/}
            {/*                            New Client*/}
            {/*                        </div>*/}
            {/*                        <div>*/}
            {/*                            <ImageConfig.ServiceCardNavigatorIcon*/}
            {/*                                color={"#66FFE0"}/>*/}
            {/*                        </div>*/}
            {/*                    </div>}*/}
            {/*                <div*/}
            {/*                    className={`${clientNewReturningType === "returning_client" ? "client-type-active" : "client-type-not-active"} cursor-pointer client-type-wrapper mrg-left-100 pdd-25 d-flex justify-content-space-between align-items-center`}*/}
            {/*                    onClick={() => {*/}
            {/*                        setClientNewReturningType("returning_client");*/}
            {/*                        if (!token) {*/}
            {/*                            dispatch(setBookingAppointmentFlowNavigation("client_form_based_client_type_selection_screen"))*/}
            {/*                        } else {*/}
            {/*                            dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"))*/}
            {/*                        }*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    <div className={'client-type-text'}>*/}
            {/*                        Returning Client*/}
            {/*                    </div>*/}
            {/*                    <div>*/}
            {/*                        <ImageConfig.ServiceCardNavigatorIcon*/}
            {/*                            color={"#66FFE0"}/>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*}*/}
            {/*Client Form Based Client Type Selection Screen*/}
            {
                currentBookingAppointmentFlowNavigation === "client_form_based_client_type_selection_screen" &&
                <div className={'client-type-screen d-flex'}>
                    <div className={'flex-1 appointment-details-holder pdd-30'}>
                        <div className={'d-flex justify-content-space-between align-items-center mrg-bottom-25'}>
                            <div className={'header-text'}>
                                Appointment Details
                            </div>
                            <div className={'d-flex'}>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center mrg-right-10'}>{selectedInjuryType === "initial_consultation" ? "Initial Consult" : "Follow-up Consult"}</div>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center'}>
                                    <div className={'mrg-right-5'}>
                                        <ImageConfig.WatchTimer color={"white"}/>
                                    </div>
                                    <div>
                                        {selectedTimeDurationAndAmount?.duration} min
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'category-details-holder_book_appointment_flow d-flex'}>
                            <div className={'active-status-show-on-card'}></div>
                            <div className={'pdd-20'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>
                                        <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                             width={60} height={40}
                                             alt={selectedServiceDetails?.name}/>
                                    </div>
                                    <div className={'category-details-text-wrapper mrg-left-20'}>
                                        <div className={'service-therapy-text'}>
                                            {selectedCategoryDetails?.name}
                                        </div>
                                        <div
                                            className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>
                                        <div>
                                            <Paragraph className={'category-description-wrapper'}
                                                       ellipsis={{rows: 2, expandable: false}}>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                                            </Paragraph>
                                            <div className={"appointment-blue-text"} onClick={() => {
                                                setIsCategoryServiceModalOpen(true)
                                            }}>
                                                Read More
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'facility-details-holder mrg-top-15'}>
                            <div className={'mrg-bottom-10 facility-details-header-text'}>Facility Details</div>
                            <div className={'d-flex  align-items-center'}>
                                <div><ImageConfig.FacilityIcon/></div>
                                <div className={'mrg-left-15'}>
                                    <div className={'facility-name-text'}>{facilityDetails?.name}</div>
                                    <div
                                        className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={'flex-1 client-type-form-holder'}>
                        <div className={'previous-button d-flex mrg-bottom-40 pdd-15'}>
                            <div
                                className={'back-arrow-holder d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                                onClick={() => {
                                    dispatch(setBookingAppointmentFlowNavigation("client_type_selection"));
                                }}>
                                <ImageConfig.LeftArrow color={"#07213C"}/>
                            </div>
                            <div
                                className={'previous-text d-flex ts-justify-content-center align-items-center mrg-left-10'}>
                                Previous
                            </div>
                        </div>
                        {clientNewReturningType === "returning_client" && <div>
                            <div className={'d-flex  align-items-center justify-content-center'}>
                                <div className={'mrg-bottom-20'}>
                                    <div className={'welcome-back-text'}>Welcome back! Let's sign you in</div>
                                    <div className={'otp-description-text mrg-top-5'}>We'll send you a verification code
                                        to
                                        your email address.
                                    </div>
                                </div>
                            </div>
                            <div className={'pdd-30 '}>
                                <Formik
                                    validationSchema={ReturningClientLoginFormValidationSchema}
                                    initialValues={LoginFormInitialValues}
                                    validateOnChange={true}
                                    validateOnBlur={true}
                                    enableReinitialize={true}
                                    validateOnMount={true}
                                    onSubmit={onOTPRequestSend}
                                >
                                    {(formik) => {
                                        const {values, validateForm, isValid, isSubmitting: isOTPBeingSent} = formik;
                                        // eslint-disable-next-line react-hooks/rules-of-hooks
                                        useEffect(() => {
                                            validateForm();
                                        }, [validateForm, values]);
                                        return (
                                            <Form className="t-form" noValidate={true}>
                                                <div className="t-form-controls">
                                                    <div className="login-form__body">
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Please enter your Client ID
                                                        </div>
                                                        <div className="login-form__body__controls t-form-controls">
                                                            <Field name={'client_id'} className="t-form-control">
                                                                {
                                                                    (field: FieldProps) => (
                                                                        <FormikInputComponent
                                                                            id={'client_id_input'}
                                                                            label={''}
                                                                            placeholder={'Enter your Client Id'}
                                                                            required={true}
                                                                            formikField={field}
                                                                            fullWidth={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Field>
                                                        </div>
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Please enter your Email Address to login
                                                        </div>
                                                        <div className="login-form__body__controls t-form-controls">
                                                            {
                                                                values.login_mode === 'email' &&
                                                                <Field name={'username'} className="t-form-control">
                                                                    {
                                                                        (field: FieldProps) => (
                                                                            <FormikInputComponent
                                                                                id={'email_input'}
                                                                                label={''}
                                                                                placeholder={'example@email.com'}
                                                                                required={true}
                                                                                formikField={field}
                                                                                fullWidth={true}
                                                                            />
                                                                        )
                                                                    }
                                                                </Field>
                                                            }
                                                            {
                                                                values.login_mode === 'phone' &&
                                                                <Field name={'username'} className="t-form-control">
                                                                    {
                                                                        (field: FieldProps) => (
                                                                            <FormikPhoneInputComponent
                                                                                id={'phone_input'}
                                                                                label={'Please enter your Cell Phone Number to login'}
                                                                                placeholder={'(000-000-0000)'}
                                                                                required={false}
                                                                                formikField={field}
                                                                                fullWidth={true}
                                                                            />
                                                                        )
                                                                    }
                                                                </Field>
                                                            }
                                                            <div className="mrg-top-80">
                                                                <ButtonComponent
                                                                    id={'proceed_btn'}
                                                                    type={"submit"}
                                                                    suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                                                    fullWidth={true}
                                                                    disabled={!isValid || isOTPBeingSent}
                                                                    isLoading={isOTPBeingSent}
                                                                >
                                                                    Proceed
                                                                </ButtonComponent>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        </div>
                        }
                        {clientNewReturningType === "new_client" && <div>
                            <div className={'d-flex  align-items-center justify-content-center'}>
                                <div className={'mrg-bottom-20'}>
                                    <div className={'welcome-back-text'}>Welcome to Kinergy Sports <br/>Medicine and
                                        Performance!
                                    </div>
                                    <div className={'otp-description-text mrg-top-5'}>Please enter your personal details
                                        below.
                                    </div>
                                </div>
                            </div>
                            <div className={'pdd-20 new-client-registration-form mrg-right-10'}>
                                <Formik
                                    validationSchema={clientFormValidationSchema}
                                    initialValues={clientFormInitialValue}
                                    validateOnChange={false}
                                    validateOnBlur={true}
                                    enableReinitialize={true}
                                    validateOnMount={true}
                                    onSubmit={onNewClientRegister}
                                >
                                    {({values, validateForm, isValid, setFieldValue, isSubmitting, dirty}) => {
                                        // eslint-disable-next-line react-hooks/rules-of-hooks
                                        useEffect(() => {
                                            validateForm();
                                        }, [validateForm, values, dirty]);
                                        return (
                                            <Form className="t-form" noValidate={true}>
                                                <FormDebuggerComponent values={values} showDebugger={false}/>
                                                <div className="request-access-form-controls">
                                                    <div className={'login-form-subtext mrg-bottom-10'}>
                                                        First Name*
                                                    </div>
                                                    <Field name={'first_name'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikInputComponent
                                                                    id={'client_first_name'}
                                                                    //  label={'First Name'}
                                                                    placeholder={'Eg., John'}
                                                                    type={"text"}
                                                                    required={true}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className={'login-form-subtext mrg-bottom-10'}>
                                                        Last Name*
                                                    </div>
                                                    <Field name={'last_name'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikInputComponent
                                                                    id={'client_last_name'}
                                                                    //label={'Last Name'}
                                                                    placeholder={'Eg., Doe'}
                                                                    type={"text"}
                                                                    required={true}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className={'login-form-subtext mrg-bottom-10'}>
                                                        Email Address*
                                                    </div>
                                                    <Field name={'primary_email'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikInputComponent
                                                                    id={'email_input'}
                                                                    //  label={'Email Address'}
                                                                    placeholder={'example@email.com'}
                                                                    type={"email"}
                                                                    required={true}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className={'login-form-subtext mrg-bottom-10'}>
                                                        Cell Phone Number*
                                                    </div>
                                                    <Field name={'primary_contact_info._phone'}>
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikPhoneInputComponent
                                                                    id={'phone_input'}
                                                                    //label={'Phone Number'}
                                                                    required={true}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className={'login-form-subtext mrg-bottom-10'}>
                                                        Date of Birth*
                                                    </div>
                                                    <Field name={'dob'} className="t-form-control">
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikDatePickerComponent
                                                                    id={'dob_input'}
                                                                    //  label={'Date of Birth'}
                                                                    placeholder={'MM-DD-YYYY'}
                                                                    required={true}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                    // clearable={true}
                                                                    maxDate={moment()}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                    <div className={'login-form-subtext mrg-bottom-10'}>Gender*</div>
                                                    <Field name={'gender'} className="t-form-control">
                                                        {
                                                            (field: FieldProps) => (
                                                                <FormikSelectDropdownComponent
                                                                    id={'gender_dd'}
                                                                    // label={'Gender'}
                                                                    options={genderList}
                                                                    isDataLoading={isGenderListLoading}
                                                                    isDataLoaded={isGenderListLoaded}
                                                                    placeholder={'Eg., Male'}
                                                                    required={true}
                                                                    isClearable={false}
                                                                    formikField={field}
                                                                    fullWidth={true}
                                                                />
                                                            )
                                                        }
                                                    </Field>
                                                </div>
                                                <div className="mrg-top-60">
                                                    <ButtonComponent
                                                        fullWidth={true}
                                                        type={'submit'}
                                                        disabled={!isValid}
                                                        className={'mrg-left-10'}
                                                        isLoading={isSubmitting}
                                                        variant={'contained'}>
                                                        Submit
                                                    </ButtonComponent>
                                                </div>
                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            }
            {
                currentBookingAppointmentFlowNavigation === "booking_appointment_for_screen" &&
                <div className={'client-type-screen d-flex'}>

                    <div className={'flex-1 appointment-details-holder pdd-30'}>
                        <div className={'d-flex justify-content-space-between align-items-center mrg-bottom-15'}>
                            <div className={'header-text'}>
                                Appointment Details
                            </div>
                            <div className={'d-flex'}>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center mrg-right-10'}>{selectedInjuryType === "initial_consultation" ? "Initial Consult" : "Follow-up Consult"}</div>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center'}>
                                    <div className={'mrg-right-5'}>
                                        <ImageConfig.WatchTimer color={"white"}/>
                                    </div>
                                    <div>
                                        {selectedTimeDurationAndAmount?.duration} min
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(internalScreen !== "booking-for-screen" && familyClientDetails) &&
                            <div className={'selected-client-details mrg-bottom-15'}>
                                Client: {familyClientDetails?.client_details?.first_name}&nbsp;{familyClientDetails?.client_details?.last_name} | {CommonService.formatPhoneNumber(familyClientDetails?.client_details?.primary_contact_info?.phone)}

                            </div>}
                        {(internalScreen !== "booking-for-screen" && appointmentForType === "my-self") &&
                            <div className={'selected-client-details mrg-bottom-15'}>
                                Client: {currentUser?.profile_viewing_as?.first_name ? currentUser?.profile_viewing_as?.first_name : currentUser?.first_name}&nbsp;{currentUser?.profile_viewing_as?.last_name ? currentUser?.profile_viewing_as?.last_name : currentUser?.last_name} | {CommonService.formatPhoneNumber(currentUser?.profile_viewing_as?.primary_contact_info?.phone ? currentUser?.profile_viewing_as?.primary_contact_info?.phone : currentUser?.primary_contact_info?.phone)}
                            </div>}
                        <div className={'category-details-holder_book_appointment_flow d-flex'}>
                            <div className={'active-status-show-on-card'}></div>
                            <div className={'pdd-20'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>
                                        <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                             width={60} height={40}
                                             alt={selectedServiceDetails?.name}/>
                                    </div>
                                    <div className={'category-details-text-wrapper mrg-left-20'}>
                                        <div className={'service-therapy-text'}>
                                            {selectedCategoryDetails?.name}
                                        </div>
                                        <div
                                            className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>
                                        <div>
                                            <Paragraph className={'category-description-wrapper'}
                                                       ellipsis={{rows: 2, expandable: false}}>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                                            </Paragraph>
                                            <div className={"appointment-blue-text"} onClick={() => {
                                                setIsCategoryServiceModalOpen(true)
                                            }}>
                                                Read More
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'facility-details-holder mrg-top-15'}>
                            <div className={'mrg-bottom-10 facility-details-header-text'}>Facility Details</div>
                            <div className={'d-flex  align-items-center'}>
                                <div><ImageConfig.FacilityIcon/></div>
                                <div className={'mrg-left-15'}>
                                    <div className={'facility-name-text'}>{facilityDetails?.name}</div>
                                    <div
                                        className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>
                                </div>
                            </div>
                        </div>
                        {selectedProviderDetails &&
                            <div className={'provider-details-holder'}>
                                <div className={'mrg-bottom-10 facility-details-header-text'}>Provider Details</div>
                                <div className={'d-flex  align-items-center'}>
                                    <div><ImageConfig.ProfileIconName color={"#B7E3FF"}/></div>
                                    <div className={'mrg-left-15'}>
                                        <div
                                            className={'facility-name-text'}>{selectedProviderDetails?.first_name}&nbsp;{selectedProviderDetails?.last_name}</div>
                                        <div className={'provider-professional-text mrg-top-5'}>
                                            {selectedProviderDetails?.professional_designation}
                                        </div>
                                        {/*<div*/}
                                        {/*    className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>*/}
                                    </div>
                                </div>
                            </div>}
                        {selectedDate &&
                            <div className={'date-time-details-holder'}>
                                <div className={'mrg-bottom-10 facility-details-header-text'}>Date And Time</div>
                                <div className={'d-flex  align-items-center'}>
                                    <div className="date-logo-avatar"><ImageConfig.CalenderTodayBlackIcon/></div>
                                    <div className={'mrg-left-15'}>
                                        <div
                                            className={'facility-name-text'}> {CommonService.getSystemFormatTimeStamp(selectedDate)}</div>
                                        {selectedTime &&
                                            <div
                                                className={'facility-address-text'}>{CommonService.getHoursAndMinutesFromMinutes(selectedTime?.timeFrame?.start_time)}
                                            </div>}
                                    </div>
                                </div>
                            </div>}
                    </div>
                    <div className={'flex-1 client-type-form-holder'}>
                        <div
                            className={'previous-button d-flex mrg-bottom-20 pdd-15 justify-content-space-between align-items-center'}>
                            <div className={'d-flex'}>
                                <div
                                    className={'back-arrow-holder d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                                    onClick={() => {
                                        // dispatch(setBookingAppointmentFlowNavigation("client_type_selection"));
                                        if (internalScreen === "select-provider") {
                                            // setAppointmentForType("");
                                            if (appointmentForType === "my-self") {
                                                setInternalScreen("booking-for-screen")
                                            }
                                            if (appointmentForType === "family-members") {
                                                setInternalScreen("someone-else-screen");
                                            }
                                        }
                                        if (internalScreen === "booking-for-screen") {
                                            dispatch(setBookingAppointmentFlowNavigation("time_rate_slot_selection_screen"))
                                            setAppointmentForType("");
                                        }
                                        if (internalScreen === "date_time_selection") {
                                            setAvailableProviderTimings([]);
                                            setSelectedDate("");
                                            setSelectedTime(null);
                                            setInternalScreen("select-provider")
                                        }
                                        if (internalScreen === "someone-else-screen") {
                                            setInternalScreen("booking-for-screen");
                                            setFamilyClientDetails(null)
                                        }
                                        if (internalScreen === "new-member-add-screen") {
                                            setInternalScreen("someone-else-screen");
                                        }
                                        if (internalScreen === "checkout_page") {
                                            setIsBookingUnblockedConfirmationModalOpen(true);
                                        }
                                        if (internalScreen === "case_selection_screen") {
                                            if (appointmentForType === "my-self") {
                                                setInternalScreen("booking-for-screen")
                                            }
                                            if (appointmentForType === "family-members") {
                                                setInternalScreen("someone-else-screen");
                                            }
                                        }
                                    }}>
                                    <ImageConfig.LeftArrow color={"#07213C"}/>
                                </div>
                                <div
                                    className={'previous-text d-flex ts-justify-content-center align-items-center mrg-left-10'}>
                                    Previous
                                </div>
                            </div>
                            <div>
                                {
                                    (couponTimer > 0 && internalScreen === "checkout_page") &&
                                    <div
                                        className={'time-remaining-wrapper-book-appointment d-flex ts-justify-content-center align-items-center'}>
                                        <div className={'mrg-right-10 d-flex ts-justify-content-center'}>
                                            <ToolTipComponent
                                                showArrow={true}
                                                position={"bottom"}
                                                tooltip={<div className={'justified-text '}>The clock is ticking – this
                                                    timer shows how long we’ll hold your appointment spot during
                                                    checkout. If time runs out, other clients will have a chance to
                                                    select this spot. However, you can still book this time slot after
                                                    the timer ends, if it's still available.</div>}>
                                                <ImageConfig.InfoFilledIcon
                                                    color={"#E84142"}/>
                                            </ToolTipComponent>
                                        </div>
                                        <div>
                                            Time
                                            Remaining: {CommonService.getMinsAndSecondsFromSeconds(couponTimer).minutes + " : " + CommonService.getMinsAndSecondsFromSeconds(couponTimer).seconds}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        {internalScreen === "case_selection_screen" &&
                            <div>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>Choose a case for this appointment.
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`case-selection-component pdd-left-40 pdd-right-40 ${(isCaseListLoading || caseList?.length === 0) && "d-flex ts-justify-content-center align-items-center text-align-center"}`}>
                                    {isCaseListLoading &&
                                        <div className={'mrg-top-40'}>
                                            <LoaderComponent type={"spinner"} color={'primary'}/>
                                        </div>
                                    }
                                    {!isCaseListLoading && caseList && caseList?.map((record: any) => {
                                        return (
                                            <div
                                                className={`case-selection-wrapper ${selectedCase?._id === record?._id ? "case-active" : "case-not-active"} mrg-bottom-15 d-flex justify-content-space-between align-items-center`}
                                                onClick={() => {
                                                    setSelectedCase(record)
                                                    dispatch(setBookingAppointmentFlowNavigation("followup-appointment-booking-screen"))
                                                }}>
                                                <div className={'d-flex ts-justify-content-center align-items-center'}>
                                                    <ToolTipComponent
                                                        tooltip={
                                                            <span>{record?.created_at && CommonService.convertDateFormat2(record?.created_at)}{' '}{record?.injury_details?.map((injury: any, index: number) => {
                                                                return <span>{injury?.body_part_details?.name} {injury?.body_side ? `(${injury?.body_side})` : ''} {index !== record?.injury_details.length - 1 ?
                                                                    <span> , </span> : ""}</span>
                                                            })}</span>} position={"bottom"}
                                                        showArrow={true}>
                                                        <div className={'medical-record-injury-details'} ref={record}>

                                                            {record?.created_at && CommonService.convertDateFormat2(record?.created_at)}{" "}
                                                            {"-"} {record?.injury_details?.map((injury: any, index: number) => {
                                                            return <span>{injury?.body_part_details?.name} {injury?.body_side ? `(${injury?.body_side})` : ''} {index !== record?.injury_details.length - 1 ?
                                                                <span> , </span> : ""}</span>
                                                        })}
                                                        </div>
                                                    </ToolTipComponent>
                                                </div>
                                                <div>
                                                    <ImageConfig.ServiceCardNavigatorIcon
                                                        color={"#66FFE0"}/>
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {
                                        !isCaseListLoading && caseList?.length === 0 && <div>
                                            <div className={'center-align-text not-found-text-for-appointment-followup'}>
                                                Oops! No case found.<br/>
                                                If you think this is incorrect, please contact us.
                                            </div>

                                            <div className={'mrg-top-100 d-flex '}>
                                                <ButtonComponent color={'accent'}
                                                                 className={'mrg-right-10'}
                                                                 variant={'outlined'} fullWidth={true}
                                                                 onClick={() => {
                                                                     setIsContactUsConfirmationModalOpen(true)
                                                                 }}
                                                >
                                                    Contact Us
                                                </ButtonComponent>
                                                <ButtonComponent
                                                    onClick={() => {
                                                        setSelectedInjuryType("initial_consultation")
                                                        dispatch(setBookingAppointmentFlowNavigation("time_rate_slot_selection_screen"))
                                                        setInternalScreen("booking-for-screen")
                                                    }}
                                                    //  isLoading={isCheckingOutInProgress}
                                                    fullWidth={true}
                                                >
                                                    Create Case
                                                </ButtonComponent>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        {internalScreen === "booking-for-screen" &&
                            <div>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>Who are you booking this<br/>
                                            appointment for?
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`client-ownership-selection-component  pdd-left-40 pdd-right-40`}>
                                    <div
                                        className={`client-ownership-selection-wrapper ${appointmentForType === "my-self" ? "active-owner" : "inactive-owner"} d-flex justify-content-space-between align-items-center`}
                                        onClick={() => {
                                            if (selectedInjuryType === "initial_consultation") {
                                                setInternalScreen("select-provider")
                                            }
                                            if (selectedInjuryType === "followup_consultation") {
                                                setInternalScreen("case_selection_screen")
                                                fetchCaseListLite(currentUser?.profile_viewing_as?._id ? currentUser?.profile_viewing_as?._id : currentUser?._id)
                                            }
                                            setAppointmentForType("my-self")
                                        }}>
                                        <div className={'d-flex ts-justify-content-center align-items-center'}>
                                            <div><ImageConfig.ProfileIconName
                                                color={`${appointmentForType === "my-self" ? "#FFFFFF" : "#B7E3FF"}`}/>
                                            </div>
                                            <div className={'mrg-left-20 ownership-profile-text'}>Myself</div>
                                        </div>
                                        <div>
                                            <ImageConfig.ServiceCardNavigatorIcon
                                                color={`${appointmentForType === "my-self" ? "#07213C" : "#66FFE0"}`}/>
                                        </div>
                                    </div>
                                    <div className="divider-container">
                                        <div className="line"></div>
                                        <span className="text">OR</span>
                                        <div className="line"></div>
                                    </div>
                                    <div
                                        className={`client-ownership-selection-wrapper ${appointmentForType === "family-members" ? "active-owner" : "inactive-owner"} d-flex justify-content-space-between align-items-center`}
                                        onClick={() => {
                                            setInternalScreen("someone-else-screen")
                                            setAppointmentForType("family-members")
                                        }}>
                                        <div className={'d-flex ts-justify-content-center align-items-center'}>
                                            <div><ImageConfig.SomeOneElseIcon
                                                color={`${appointmentForType === "family-members" ? "#FFFFFF" : "#B7E3FF"}`}/>
                                            </div>
                                            <div className={'mrg-left-20 ownership-profile-text'}>Someone Else</div>
                                        </div>
                                        <div>
                                            <ImageConfig.ServiceCardNavigatorIcon
                                                color={`${appointmentForType === "family-members" ? "#07213C" : "#66FFE0"}`}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            internalScreen === "someone-else-screen" && <div>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>Who is this appointment for?
                                        </div>
                                    </div>
                                </div>
                                <div className={'pdd-left-40 pdd-right-40'}>
                                    <div className={'some-one-else-screen-wrapper'}>
                                        {accessibleAccounts?.length > 0 &&
                                            <div className={'available-client-wrapper'}>
                                                {accessibleAccounts && accessibleAccounts?.map((account: any, index: number) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className={`${familyClientDetails?.client_details?._id === account?.client_details?._id ? "someone-else-active" : "someone-else-not-active"} someone-else-selection-wrapper d-flex justify-content-space-between align-items-center mrg-bottom-10`}
                                                            onClick={() => {
                                                                if (selectedInjuryType === "initial_consultation") {
                                                                    setInternalScreen("select-provider")
                                                                }
                                                                if (selectedInjuryType === "followup_consultation") {
                                                                    setInternalScreen("case_selection_screen")
                                                                    fetchCaseListLite(account?.client_details?._id)
                                                                }
                                                                setFamilyClientDetails(account)
                                                            }}>
                                                            <div
                                                                className={'d-flex ts-justify-content-center align-items-center'}>
                                                                <div><ImageConfig.ProfileIconName color={"#B7E3FF"}/>
                                                                </div>
                                                                <div
                                                                    className={'mrg-left-20 ownership-profile-text'}>{account?.client_details?.first_name + " " + account?.client_details?.last_name}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <ImageConfig.ServiceCardNavigatorIcon
                                                                    color={"#66FFE0"}/>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                {accessibleAccounts?.length > 0 &&
                                                    <div className="divider-container">
                                                        <div className="line"></div>
                                                        <span className="text">OR</span>
                                                        <div className="line"></div>
                                                    </div>}
                                                <div
                                                    className={'someone-else-selection-wrapper someone-else-not-active d-flex justify-content-space-between align-items-center mrg-bottom-10'}
                                                    onClick={() => {
                                                        setInternalScreen("new-member-add-screen")
                                                    }}>
                                                    <div
                                                        className={'d-flex ts-justify-content-center align-items-center'}>
                                                        <div><ImageConfig.BookAppointmentPlusIcon/></div>
                                                        <div className={'mrg-left-20 ownership-profile-text'}>Add New
                                                            Client
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <ImageConfig.ServiceCardNavigatorIcon
                                                            color={"#66FFE0"}/>
                                                    </div>
                                                </div>
                                            </div>}


                                    </div>
                                </div>

                            </div>
                        }

                        {
                            internalScreen === "new-member-add-screen" &&
                            <div>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>New Client Details
                                        </div>
                                        <div className={'otp-description-text mrg-top-5'}>Please enter the client's
                                            information below.
                                        </div>
                                    </div>
                                </div>
                                <div className={"pdd-left-40 pdd-right-40 some-one-else-form-wrapper"}>
                                    <Formik
                                        validationSchema={someOneElseFormValidationSchema}
                                        initialValues={someoneElseFormInitialValue}
                                        validateOnChange={false}
                                        validateOnBlur={true}
                                        enableReinitialize={true}
                                        validateOnMount={true}
                                        onSubmit={onSomeOneElseSubmit}
                                    >
                                        {({values, validateForm, isValid, setFieldValue, isSubmitting, dirty}) => {
                                            // eslint-disable-next-line react-hooks/rules-of-hooks
                                            useEffect(() => {
                                                validateForm();
                                            }, [validateForm, values, dirty]);
                                            return (
                                                <Form className="t-form" noValidate={true}>
                                                    <FormDebuggerComponent values={values} showDebugger={false}/>
                                                    <div className="request-access-form-controls">
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            First Name*
                                                        </div>
                                                        <Field name={'first_name'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        id={'client_first_name'}
                                                                        placeholder={'E.g., John'}
                                                                        type={"text"}
                                                                        required={true}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Last Name*
                                                        </div>
                                                        <Field name={'last_name'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikInputComponent
                                                                        id={'client_last_name'}
                                                                        //  label={'Last Name'}
                                                                        placeholder={'E.g., Doe'}
                                                                        type={"text"}
                                                                        required={true}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Date of Birth*
                                                        </div>
                                                        <Field name={'dob'} className="t-form-control">
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikDatePickerComponent
                                                                        id={'dob_input'}
                                                                        //  label={'Date of Birth'}
                                                                        placeholder={'MM-DD-YYYY'}
                                                                        required={true}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                        // clearable={true}
                                                                        maxDate={moment()}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Gender*
                                                        </div>
                                                        <Field name={'gender'} className="t-form-control">
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        id={'gender_dd'}
                                                                        //label={'Gender'}
                                                                        options={genderList}
                                                                        isDataLoading={isGenderListLoading}
                                                                        isDataLoaded={isGenderListLoaded}
                                                                        placeholder={'E.g., Male'}
                                                                        required={true}
                                                                        isClearable={false}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                        <div className={'login-form-subtext mrg-bottom-10'}>
                                                            Relationship to the client*
                                                        </div>
                                                        <Field
                                                            name={'relationship'}>
                                                            {
                                                                (field: FieldProps) => (
                                                                    <FormikSelectDropdownComponent
                                                                        options={relationshipList}
                                                                        //label={'Relationship to the client'}
                                                                        placeholder={'E.g., Manager'}
                                                                        required={true}
                                                                        formikField={field}
                                                                        fullWidth={true}
                                                                        isClearable={false}
                                                                    />
                                                                )
                                                            }
                                                        </Field>
                                                        <div className="form-question">
                                                            <div
                                                                className="form-question-text d-flex justify-content-space-between">
                                                                <div className={'d-flex'}>
                                                                    <div>
                                                                        Is this a profile of a dependent?
                                                                    </div>
                                                                    <div>
                                                                        <IconButtonComponent
                                                                            className={"form-helper-icon mrg-left-5 mrg-right-100"}>
                                                                            <ToolTipComponent
                                                                                showArrow={true}
                                                                                position={"right"}
                                                                                tooltip={<div
                                                                                    className={'dependant-wrapper'}>A <span
                                                                                    className={'dependant-profile-text'}>dependent profile </span>
                                                                                    is an
                                                                                    account created for someone who is
                                                                                    unable to manage their own account
                                                                                    due to age or physical/mental
                                                                                    challenges. Typically, this profile
                                                                                    is linked to the main account of an
                                                                                    individual (like a parent or
                                                                                    guardian), who has control over the
                                                                                    account's settings and activity.
                                                                                    Dependent profiles are often used
                                                                                    for children under 18 or individuals
                                                                                    with disabilities, allowing the
                                                                                    responsible party to monitor or
                                                                                    limit access to certain content or
                                                                                    features. This account will be under
                                                                                    your email address and cell phone
                                                                                    number.</div>}>
                                                                                <ImageConfig.InfoFilledIcon
                                                                                    className={'info-icon'}/>
                                                                            </ToolTipComponent>
                                                                        </IconButtonComponent>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Field name={'is_dependent'}>
                                                                        {
                                                                            (field: FieldProps) => (
                                                                                <FormikRadioButtonGroupComponent
                                                                                    options={CommonService._staticData.yesNoOptions}
                                                                                    required={true}
                                                                                    displayWith={(option) => option.title}
                                                                                    valueExtractor={(option) => option.code}
                                                                                    formikField={field}
                                                                                    onChange={(value: any) => {
                                                                                        if (value === true) {
                                                                                            setFieldValue(' _primary_email', '');
                                                                                            setFieldValue('_primary_contact_info._phone', '')
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            )
                                                                        }
                                                                    </Field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            values?.is_dependent === false && <div>
                                                                <div className={'login-form-subtext mrg-bottom-10'}>
                                                                    Email Address*
                                                                </div>
                                                                <Field name={'primary_email'}>
                                                                    {
                                                                        (field: FieldProps) => (
                                                                            <FormikInputComponent
                                                                                id={'email_input'}
                                                                                //  label={'Email Address'}
                                                                                placeholder={'example@email.com'}
                                                                                type={"email"}
                                                                                required={true}
                                                                                formikField={field}
                                                                                fullWidth={true}
                                                                            />
                                                                        )
                                                                    }
                                                                </Field>
                                                                <div className={'login-form-subtext mrg-bottom-10'}>
                                                                    Cell Phone Number*
                                                                </div>
                                                                <Field name={'primary_contact_info.phone'}>
                                                                    {
                                                                        (field: FieldProps) => (
                                                                            <FormikPhoneInputComponent
                                                                                id={'phone_input'}
                                                                                placeholder={'(000) 000-0000'}
                                                                                //label={'Phone Number'}
                                                                                required={true}
                                                                                formikField={field}
                                                                                fullWidth={true}
                                                                            />
                                                                        )
                                                                    }
                                                                </Field>

                                                            </div>
                                                        }
                                                    </div>


                                                    <div className="mrg-top-60">
                                                        <ButtonComponent
                                                            fullWidth={true}
                                                            type={'submit'}
                                                            disabled={!isValid}
                                                            //className={'mrg-left-10'}
                                                            isLoading={isSubmitting}
                                                            variant={'contained'}>
                                                            Register
                                                        </ButtonComponent>
                                                    </div>

                                                </Form>
                                            )
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        }

                        {
                            internalScreen === "select-provider" &&
                            <div>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>Select Provider
                                        </div>
                                    </div>
                                </div>
                                <div className={'pdd-left-40 pdd-right-40'}>
                                    <div className={'select-provider-wrapper'}>
                                        {providerListBasedOnCategoryFacilitySelected && providerListBasedOnCategoryFacilitySelected?.map((provider: any, index: any) => {
                                            return (
                                                <div
                                                    className={`${selectedProviderDetails?._id === provider?._id ? "provider-active" : "provider-not-active"} provider-profile-card mrg-right-10 d-flex mrg-bottom-15 align-items-center`}
                                                    key={index} onClick={() => {
                                                    setSelectedProviderDetails(provider)
                                                    setInternalScreen("date_time_selection")
                                                    fetchProviderAvailableDates(provider?._id)
                                                }}>
                                                    <div className={'name-short-hand-holder'}>
                                                        {CommonService.getFirstLetterCapitalized(provider?.first_name)}{CommonService.getFirstLetterCapitalized(provider?.last_name)}
                                                    </div>
                                                    {/*<div>*/}
                                                    {/*    {JSON.stringify(provider)}*/}
                                                    {/*</div>*/}
                                                    <div className={'mrg-left-25'}>
                                                        <div
                                                            className="profile-name">{provider?.first_name + " " + provider?.last_name}</div>
                                                        <div className={'professional-designation-text mrg-top-5'}>
                                                            {provider?.professional_designation || "Atheletic Therapist / Trainer"}
                                                        </div>
                                                        <div
                                                            className="text-fourteen-font  mrg-top-10 cursor-pointer"
                                                            onClick={() => {
                                                                setIsProviderDetailsModalOpen(true);
                                                                fetchProviderDetails(provider?._id)
                                                            }}>
                                                            View Profile
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            internalScreen === "date_time_selection" &&
                            <div className={'date-time-selection-component'}>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-20'}>
                                        <div className={'welcome-back-text'}>Select
                                            Date {availableProviderTimings?.length > 0 ? "And Time" : ""}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`${selectedDate && "pdd-left-40"} d-flex ts-justify-content-center align-items-center`}>
                                    {/*<CustomCalendar onDateSelect={(e) => {*/}
                                    {/*    console.log(e)*/}
                                    {/*}}/>*/}
                                    {isAvailableProviderDatesLoading &&
                                        <div className={'mrg-top-40'}>
                                            <LoaderComponent type={"spinner"} color={'primary'}/>
                                        </div>
                                    }
                                    {!isAvailableProviderDatesLoading && !selectedDate &&
                                        <BookAppointmentCalender calenderSize={"xl"} onDateSelect={(e: any) => {
                                            setAvailableProviderTimings([])
                                            fetchProviderAvailableTimings(moment(e).format('YYYY-MM-DD'))
                                            setSelectedDate(moment(e).format('YYYY-MM-DD'))
                                            setSelectedTime(null)
                                        }} enabledDates={availableProviderDates || []}/>}
                                    {!isAvailableProviderDatesLoading && selectedDate &&
                                        <div className={'d-flex'}>
                                            <div style={{
                                                borderRight: "1px solid #EBEBEB"
                                            }} className={'pdd-right-10'}>
                                                <BookAppointmentCalender defaultDate={selectedDate}
                                                                         onDateSelect={(e: any) => {
                                                                             setAvailableProviderTimings([])
                                                                             fetchProviderAvailableTimings(moment(e).format('YYYY-MM-DD'))
                                                                             setSelectedDate(moment(e).format('YYYY-MM-DD'))
                                                                             setSelectedTime(null)
                                                                         }}
                                                                         enabledDates={availableProviderDates || []}/>
                                                <div className={'d-flex mrg-top-10'}>
                                                    <div className={'mrg-right-5'}><ImageConfig.PhoneIcon
                                                        color={"#1479FF"}/></div>
                                                    <div className={'details-contact-text'}>
                                                        If you're unable to find a suitable date and time<br/> or need
                                                        assistance with booking your appointment,<br/> please call us at
                                                        <span className={'bold-phone'}> (000) 000-0000.</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'pdd-left-10'}>
                                                <div className={'date-details-header mrg-bottom-20'}>
                                                    {selectedDate ? CommonService.formatDateInDayAlphabet(selectedDate) : "No date Selected"}
                                                </div>
                                                <div className={'available-times-holder'}>
                                                    {isAvailableProviderTimingsLoading &&
                                                        <div className={'mrg-top-40 mrg-left-50'}>
                                                            <LoaderComponent type={"spinner"} color={'primary'}/>
                                                        </div>
                                                    }
                                                    {!isAvailableProviderTimingsLoading &&
                                                        availableProviderTimings?.map((timings: any, index: any) => {
                                                            return (
                                                                <div key={index}
                                                                     className={`time-wrapper mrg-bottom-10 ${selectedTime?.indexNumber === index ? "time-active" : "time-not-active"}`}
                                                                     onClick={() => {
                                                                         setSelectedTime({
                                                                             timeFrame: timings,
                                                                             indexNumber: index
                                                                         })
                                                                     }}
                                                                >
                                                                    {CommonService.getHoursAndMinutesFromMinutes(timings?.start_time)} - {CommonService.getHoursAndMinutesFromMinutes(timings?.end_time)}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {!isAvailableProviderDatesLoading && selectedDate &&
                                    <div
                                        className="login-form__body__controls__button mrg-left-40 mrg-right-40 mrg-top-10">
                                        <ButtonComponent
                                            fullWidth={true}
                                            disabled={!selectedDate || !selectedTime}
                                            suffixIcon={<ImageConfig.RightArrow/>}
                                            onClick={() => {
                                                BlockTheSlotApiCall();
                                            }}
                                        >
                                            Next
                                        </ButtonComponent>
                                    </div>}
                            </div>
                        }
                        {
                            internalScreen === "checkout_page" &&
                            <div className={'checkout-screen-component'}>
                                <div className={'d-flex  align-items-center justify-content-center'}>
                                    <div className={'mrg-bottom-30'}>
                                        <div className={'welcome-back-text'}>Secure Checkout
                                        </div>
                                    </div>
                                </div>
                                <div className={'mrg-left-40 mrg-right-20 secure-checkout-wrapper'}>
                                    <div>
                                        <div className={'total-amount-header'}>Total Amount (Incl. tax)</div>
                                        <div
                                            className={'total-amount-value'}>${Number(selectedTimeDurationAndAmount?.amount).toFixed(2)}</div>
                                    </div>
                                    <div className={'login-form-subtext mrg-bottom-10 mrg-top-25'}>
                                        Add a gift card or promotion code or voucher
                                    </div>
                                    <div className={'d-flex'}>
                                        <div className={'flex-1 code-input-wrapper'}>
                                            <InputComponent value={checkOutCode} placeholder={'Enter code'} fullWidth
                                                            endIcon={
                                                                checkOutCode &&
                                                                <div className={'cursor-pointer'} onClick={() => {
                                                                    setCheckOutCode(null);
                                                                    setCouponCodeAppliedData(null)
                                                                }}>
                                                                    <ImageConfig.InputCrossIcon/>
                                                                </div>
                                                            }
                                                            onChange={(code: any) => {
                                                                setCheckOutCode(code);
                                                                setCouponCodeAppliedData(null)
                                                            }}/>
                                        </div>
                                        <div className={'d-flex justify-content-center align-items-center mrg-left-15'}>
                                            <ButtonComponent
                                                disabled={!checkOutCode || isCouponCodeDataLoading || couponCodeAppliedData}
                                                isLoading={isCouponCodeDataLoading}
                                                onClick={() => {
                                                    ApplyCouponApiCall()
                                                }}
                                                className={'button-apply-code'}
                                                variant={'outlined'}
                                                color={'accent'}
                                            >

                                                {couponCodeAppliedData ? "Applied" : "Apply"}
                                            </ButtonComponent>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={'mrg-top-25 mrg-bottom-15 checkout-summary-header'}>Checkout
                                            Summary
                                        </div>
                                        <div className={'d-flex justify-content-space-between mrg-bottom-10'}>
                                            <div className={'amount-sub-header'}>Amount (Incl. tax)</div>
                                            <div
                                                className={'amount-sub-header-value'}>${Number(selectedTimeDurationAndAmount?.amount).toFixed(2)}</div>
                                        </div>
                                        <div className={'d-flex justify-content-space-between mrg-bottom-25'}>
                                            <div className={'amount-sub-header'}>Discount</div>
                                            <div
                                                className={'amount-sub-header-value'}>
                                                {(couponCodeAppliedData && couponCodeAppliedData?.discount_type === "percentage") &&
                                                    <div>
                                                        ${CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount)}
                                                    </div>
                                                }
                                                {(couponCodeAppliedData && couponCodeAppliedData?.discount_type === "amount") &&
                                                    <div>
                                                        ${couponCodeAppliedData?.amount}
                                                    </div>
                                                }
                                                {!couponCodeAppliedData &&
                                                    <div>
                                                        $0.00
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className={'d-flex justify-content-space-between'}>
                                            <div className={'total-amount-sub-header'}>Total Amount (Incl. tax)</div>
                                            <div
                                                className={'total-amount-sub-value'}>$
                                                {!couponCodeAppliedData &&
                                                    <span>
                                                    {Number(selectedTimeDurationAndAmount?.amount).toFixed(2)}
                                                </span>}
                                                {couponCodeAppliedData &&
                                                    <span>
                                                    {Number(Number(selectedTimeDurationAndAmount?.amount) - (couponCodeAppliedData?.discount_type === "percentage" ? CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount) : couponCodeAppliedData?.amount)).toFixed(2)}
                                                </span>}
                                            </div>
                                        </div>
                                        <div className={''}>
                                            <div>
                                                <CheckBoxComponent label={''}
                                                                   value={isAttendancePolicyChecked}
                                                                   onChange={() => setIsAttendancePolicyChecked(prev => !prev)}
                                                />
                                            </div>
                                            <div className={'mrg-left-30'}> Reviewed the
                                                <span className={'blue-text underline-text-decoration'}
                                                      onClick={() => {
                                                          setIsAttendanceModalOpen(true);
                                                      }}> Attendance/Cancellation Policy.</span>
                                            </div>
                                        </div>
                                        <div>
                                            <ButtonComponent
                                                disabled={!isAttendancePolicyChecked}
                                                className={'mrg-top-40'}
                                                onClick={() => {
                                                    //  BookAppointmentApiCall();
                                                    setIsCheckoutConfirmationModalOpen(true)
                                                }}
                                                //   onClick={handleSecureCheckout}
                                                //  isLoading={isCheckingOutInProgress}
                                                fullWidth={true}
                                            >
                                                Check Out
                                            </ButtonComponent>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </div>
            }
            {
                currentBookingAppointmentFlowNavigation === "followup-appointment-booking-screen" &&
                <div className={'follow-up-booking-component pdd-30'}>
                    <div className={'mrg-bottom-25 d-flex justify-content-space-between'}>
                        <div className={'d-flex align-items-center'}>
                            <div className={'follow-up-previous-button d-flex'}>
                                <div className={'d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                                     onClick={() => {
                                         dispatch(setBookingAppointmentFlowNavigation("booking_appointment_for_screen"));
                                         setInternalScreen("case_selection_screen")
                                     }}>
                                    <ImageConfig.LeftArrow color={"#66FFE0"}/>
                                </div>
                                <div
                                    className={'d-flex ts-justify-content-center align-items-center'}>
                                    Previous
                                </div>
                            </div>
                            <div className={'header-text mrg-left-20'}>
                                Appointment Details
                            </div>
                        </div>
                        <div className={'d-flex'}>
                            {(internalScreen !== "booking-for-screen" && familyClientDetails) &&
                                <div className={'selected-client-details'}>
                                    Client: {familyClientDetails?.client_details?.first_name}&nbsp;{familyClientDetails?.client_details?.last_name} | {CommonService.formatPhoneNumber(familyClientDetails?.client_details?.primary_contact_info?.phone)}

                                </div>}
                            {(internalScreen !== "booking-for-screen" && appointmentForType === "my-self") &&
                                <div className={'selected-client-details'}>
                                    Client: {currentUser?.profile_viewing_as?.first_name ? currentUser?.profile_viewing_as?.first_name : currentUser?.first_name}&nbsp;{currentUser?.profile_viewing_as?.last_name ? currentUser?.profile_viewing_as?.last_name : currentUser?.last_name} | {CommonService.formatPhoneNumber(currentUser?.profile_viewing_as?.primary_contact_info?.phone ? currentUser?.profile_viewing_as?.primary_contact_info?.phone : currentUser?.primary_contact_info?.phone)}
                                </div>}
                            <div className={'d-flex'}>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center mrg-right-10 mrg-left-10'}>{selectedInjuryType === "initial_consultation" ? "Initial Consult" : "Follow-up"}</div>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center'}>
                                    <div className={'mrg-right-5'}>
                                        <ImageConfig.WatchTimer color={"white"}/>
                                    </div>
                                    <div>
                                        {selectedTimeDurationAndAmount?.duration} min
                                    </div>
                                </div>
                            </div>
                            {
                                (remainingTimeForFollowUpBooking > 0) &&
                                <div
                                    className={'time-remaining-wrapper-book-appointment d-flex ts-justify-content-center align-items-center mrg-left-10'}>
                                    <div className={'mrg-right-10 d-flex ts-justify-content-center'}>
                                        <ToolTipComponent
                                            showArrow={true}
                                            position={"bottom"}
                                            tooltip={<div>The clock is ticking – this timer shows how long we’ll
                                                hold your appointment spot during checkout. If time runs out, other
                                                clients will have a chance to select this spot. However, you can
                                                still book this time slot after the timer ends, if it's still
                                                available.</div>}>
                                            <ImageConfig.InfoFilledIcon
                                                color={"#E84142"}/>
                                        </ToolTipComponent>
                                    </div>
                                    <div>
                                        Time
                                        Remaining: {CommonService.getMinsAndSecondsFromSeconds(remainingTimeForFollowUpBooking).minutes + " : " + CommonService.getMinsAndSecondsFromSeconds(remainingTimeForFollowUpBooking).seconds}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className={'d-flex mrg-bottom-20'}>
                        <div className={'category-details-holder_book_appointment_flow d-flex flex-1 mrg-right-5'}>
                            <div className={'active-status-show-on-card'}></div>
                            <div className={'pdd-20 d-flex flex-1'}>
                                <div className={'d-flex align-items-center flex-1'}>
                                    <div>
                                        <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                             width={60} height={41}
                                             alt={selectedServiceDetails?.name}/>
                                    </div>
                                    <div
                                        className={'category-details-text-wrapper mrg-left-20 d-flex justify-content-space-between align-items-center flex-1'}>
                                        <div className={'d-flex justify-content-space-between flex-1'}>
                                            <div
                                                className={' mrg-bottom-5'}>
                                                <div className={'service-therapy-text'}>
                                                    {selectedCategoryDetails?.name}
                                                </div>
                                                <div
                                                    className={'category-name-text-in-details mrg-bottom-5'}>
                                                    {selectedServiceDetails?.name}
                                                </div>
                                            </div>
                                            <div className={"appointment-blue-text mrg-left"} onClick={() => {
                                                setIsCategoryServiceModalOpen(true)
                                            }}>
                                                Know more
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'facility-details-holder flex-1 mrg-right-5'}>
                            <div className={'mrg-bottom-10 facility-details-header-text'}>Facility Details</div>
                            <div className={'d-flex  align-items-center'}>
                                <div><ImageConfig.FacilityIcon/></div>
                                <div className={'mrg-left-15'}>
                                    <div className={'facility-name-text'}>{facilityDetails?.name}</div>
                                    <div
                                        className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>
                                </div>
                            </div>
                        </div>
                        <div className={'provider-details-holder flex-1 mrg-right-5'}>
                            <div className={'mrg-bottom-10 facility-details-header-text'}>Case Name</div>
                            <div className={'d-flex  align-items-center'}>
                                <div><ImageConfig.CaseIconName/></div>
                                <div className={'mrg-left-15'}>
                                    <ToolTipComponent showArrow={true}
                                                      position={"bottom"}
                                                      tooltip={
                                                          <div> {selectedCase?.created_at && CommonService.convertDateFormat2(selectedCase?.created_at)}{" "}
                                                              {"-"} {selectedCase?.injury_details?.map((injury: any, index: number) => {
                                                                  return <span>{injury?.body_part_details?.name} {injury?.body_side ? `(${injury?.body_side})` : ''} {index !== selectedCase?.injury_details.length - 1 ?
                                                                      <span> , </span> : ""}</span>
                                                              })}</div>}>
                                        <div
                                            className={'facility-name-text'}>
                                            {selectedCase?.created_at && CommonService.convertDateFormat2(selectedCase?.created_at)}{" "}
                                            {"-"} {selectedCase?.injury_details?.map((injury: any, index: number) => {
                                            return <span>{injury?.body_part_details?.name} {injury?.body_side ? `(${injury?.body_side})` : ''} {index !== selectedCase?.injury_details.length - 1 ?
                                                <span> , </span> : ""}</span>
                                        })}
                                        </div>
                                    </ToolTipComponent>
                                    {/*<div*/}
                                    {/*    className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>*/}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={'d-flex'}>
                        <div className={'follow-up-calender-timings-wrapper pdd-20'}>
                            <div className={'d-flex'}>
                                <div style={{
                                    paddingRight: "7px",
                                    borderRight: "1px solid #1F3864"
                                }}>
                                    <div className={'d-flex mrg-bottom-25'}>
                                        <div className={'d-flex ts-align-items-center flex-3 provider-header'}>Select
                                            Provider and Date
                                        </div>
                                        <div className={'provider-follow-up-appointment-select-box flex-3'}>
                                            <SelectDropdownComponent
                                                size={"small"}
                                                placeholder={"Select Provider"}
                                                value={selectedProviderDetails}
                                                options={providerListBasedOnCategoryFacilitySelected}
                                                displayWith={(option: any) => `${CommonService.capitalizeFirstLetter(option?.first_name)} ${CommonService.capitalizeFirstLetter(option?.last_name)}`}
                                                valueExtractor={(option: any) => option}
                                                onUpdate={(value: any) => {
                                                    if (rowId) {
                                                        setAppointmentData((prevData: any) => ({
                                                            ...prevData,
                                                            sessions: prevData.sessions.map((session: any) =>
                                                                session.initial_id === rowId
                                                                    ? {
                                                                        ...session,
                                                                        provider_id: value?._id,
                                                                        provider_details: value,
                                                                        appointment_date: null,
                                                                        start_time: null,
                                                                        end_time: null
                                                                    } // Update only this session
                                                                    : session
                                                            ),
                                                        }));
                                                        if (previouslySelectedRow?.appointment_date && previouslySelectedRow?.start_time !== null && previouslySelectedRow?.end_time !== null && previouslySelectedRow?.provider_id) {
                                                            UnBlockTheFollowUpAppointmentApiCall(previouslySelectedRow?.appointment_date, previouslySelectedRow?.start_time, previouslySelectedRow?.end_time, previouslySelectedRow?.provider_id)
                                                        }
                                                    }
                                                    setSelectedProviderDetails(value)
                                                    fetchProviderAvailableDates(value?._id)
                                                    setSelectedDateForProviderFollowUp(null)
                                                    setAvailableProviderTimings([])
                                                }}
                                            />
                                        </div>
                                        <div
                                            className={'flex-1 d-flex ts-align-items-center view-profile-text mrg-left-15 '}>
                                            {selectedProviderDetails &&
                                                <div className={"cursor-pointer"} onClick={() => {
                                                    setIsProviderDetailsModalOpen(true);
                                                    fetchProviderDetails(selectedProviderDetails?._id)
                                                }}>
                                                    View profile
                                                </div>}
                                        </div>
                                    </div>
                                    {!selectedProviderDetails &&
                                        <div className={'selection-null-text'}>
                                            Please select a provider first
                                        </div>
                                    }
                                    {selectedProviderDetails &&
                                        <BookAppointmentFollowUpCalender enabledDates={availableProviderDates || []}
                                                                         defaultDate={selectedDateForProviderFollowUp}
                                                                         onDateSelect={(e: any) => {
                                                                             if (rowId) {
                                                                                 setAppointmentData((prevData: any) => ({
                                                                                     ...prevData,
                                                                                     sessions: prevData.sessions.map((session: any) =>
                                                                                         session.initial_id === rowId
                                                                                             ? {
                                                                                                 ...session,
                                                                                                 appointment_date: moment(e).format('YYYY-MM-DD'),
                                                                                                 start_time: null
                                                                                             } // Update only this session
                                                                                             : session
                                                                                     ),
                                                                                 }));
                                                                                 if (previouslySelectedRow?.appointment_date && previouslySelectedRow?.start_time !== null && previouslySelectedRow?.end_time !== null && previouslySelectedRow?.provider_id) {
                                                                                     UnBlockTheFollowUpAppointmentApiCall(previouslySelectedRow?.appointment_date, previouslySelectedRow?.start_time, previouslySelectedRow?.end_time, previouslySelectedRow?.provider_id)
                                                                                 }
                                                                             }
                                                                             setAvailableProviderTimings([])
                                                                             //  fetchProviderAvailableTimings(moment(e).format('YYYY-MM-DD'))
                                                                             setSelectedDateForProviderFollowUp(moment(e).format('YYYY-MM-DD'))
                                                                         }}/>
                                    }
                                </div>

                                <div>
                                    <div
                                        className={'d-flex ts-justify-content-center mrg-bottom-20 follow-up-select-time-header'}>
                                        Select Time
                                    </div>
                                    <div
                                        className={`follow-up-available-times-holder mrg-left-10 ${(isAvailableProviderTimingsLoading || !selectedDateForProviderFollowUp) && "d-flex justify-content-center align-items-center"}`}>
                                        {isAvailableProviderTimingsLoading &&
                                            <div className={'mrg-top-40 mrg-left-50'}>
                                                <LoaderComponent type={"spinner"}/>
                                            </div>
                                        }
                                        {
                                            !selectedDateForProviderFollowUp &&
                                            <div className={'date-non-selected-text'}>
                                                Please select a <br/> date
                                            </div>
                                        }
                                        {!isAvailableProviderTimingsLoading &&
                                            availableProviderTimings?.map((timings: any, index: any) => {
                                                const isBooked = bookedSlots?.some(
                                                    (session: any) =>
                                                        session.start_time === timings.start_time && session.end_time === timings.end_time
                                                );
                                                return (
                                                    <div key={index}
                                                         className={`time-wrapper mrg-bottom-10  ${
                                                             isBooked ? "time-disabled" : "time-available"
                                                         }`}
                                                         onClick={() => {
                                                             if (!isBooked) {
                                                                 BlockTheFollowUpAppointmentSlotApiCall(timings)
                                                                 //  handleInitialFollowBookAppointment(timings)
                                                             } else {
                                                                 // CommonService._alert.showToast("Slot Already Booked", "error")
                                                             }
                                                         }}
                                                    >
                                                        {CommonService.getHoursAndMinutesFromMinutes(timings?.start_time)} - {CommonService.getHoursAndMinutesFromMinutes(timings?.end_time)}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'mrg-left-5'}>
                            <div className="appointments-container d-flex flex-direction-column">
                                <div className={'d-flex justify-content-space-between mrg-bottom-15'}>
                                    <div className="appointments-header">Total
                                        Appointments: {appointmentData?.sessions?.length || "NA"}</div>
                                    <div className={'add-followup-appointment-button'}>
                                        <ButtonComponent
                                            disabled={!appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.provider_id || !appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.appointment_date || !appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.start_time}
                                            variant={"text-button"} color={"primary"} onClick={() => {
                                            setSelectedProviderDetails(null)
                                            setSelectedDateForProviderFollowUp(null)
                                            setAvailableProviderTimings([])
                                            const newSession: any = {
                                                provider_id: null,
                                                provider_details: null,
                                                appointment_date: null,
                                                start_time: null,
                                                end_time: null,
                                                initial_id: CommonService.getUUID(),
                                                //  appointment_dateTime_utc: utcDateTime.toISOString(),
                                            };
                                            setRowId(newSession?.initial_id)
                                            setNewlyAddedRowId(newSession?.initial_id)
                                            setPreviouslySelectedRow(newSession)
                                            setAppointmentData((prev: any) => ({
                                                ...prev,
                                                sessions: [...prev.sessions, newSession],
                                            }));
                                        }}>
                                          <span className={'mrg-right-5'} style={{
                                              fontSize: "20px",
                                          }}>+</span> Add Another Appointment
                                        </ButtonComponent>
                                    </div>
                                </div>

                                <div className="appointments-scroll flex-1">
                                    <div className="appointments-list">
                                        <div className="appointments-header-row">
                                            <div className="column-header-provider">Provider</div>
                                            <div className="column-header">Date</div>
                                            <div className="column-header">Time</div>
                                            <div className="column-header"></div>
                                        </div>
                                        <div className={'appointments-list-body-follow-up'}>
                                            {
                                                appointmentData?.sessions?.length === 0 &&
                                                <div key={0} className="appointment-row">
                                                    <div className="provider-name">
                                                        -
                                                    </div>
                                                    <div
                                                        className="appointment-date">-
                                                    </div>
                                                    <div className="appointment-time">
                                                        -
                                                    </div>
                                                    <div className="action-buttons">
                                                        <div className={'cursor-not-allowed'}>
                                                            <ImageConfig.EditIcon width={18} height={18}
                                                                                  color={"#83909D"}/>
                                                        </div>
                                                        <div className={'mrg-left-10 cursor-not-allowed'}>
                                                            <ImageConfig.DeleteIcon width={18} height={18}
                                                                                    color={"#83909D"}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {appointmentData?.sessions?.map((appointment: any, index: number) => (
                                                <div key={index} className="appointment-row">
                                                    <div className="provider-name">
                                                        {appointment?.provider_details?.first_name ? (appointment?.provider_details?.first_name + " " + appointment?.provider_details?.last_name) : "-"}
                                                    </div>
                                                    <div
                                                        className="appointment-date">{appointment?.appointment_date ? CommonService.getSystemFormatTimeStamp(appointment?.appointment_date) : "-"}</div>
                                                    <div className="appointment-time">
                                                        {appointment?.start_time === null ? "-" : CommonService.getHoursAndMinutesFromMinutes(appointment?.start_time)}
                                                    </div>
                                                    <div className="action-buttons">
                                                        <div className={'cursor-pointer'} onClick={() => {
                                                            setRowId(appointment?.initial_id)
                                                            setSelectedDateForProviderFollowUp(appointment?.appointment_date)
                                                            setSelectedProviderDetails(appointment?.provider_details)
                                                            setPreviouslySelectedRow(appointment)
                                                            setNewlyAddedRowId(null)
                                                        }}>
                                                            <ImageConfig.EditIcon width={18} height={18}
                                                                                  color={(!newlyAddedRowId && rowId === appointment?.initial_id) ? "#66FFE0" : "#83909D"}/>
                                                        </div>
                                                        <div className={'mrg-left-10 cursor-pointer'} onClick={() => {
                                                            handleRemoveSession(appointment)
                                                            UnBlockTheFollowUpAppointmentApiCall(appointment?.appointment_date, appointment?.start_time, appointment?.end_time, appointment?.provider_id)
                                                        }}>
                                                            <ImageConfig.DeleteIcon width={18} height={18}
                                                                                    color={"#E84142"}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={'mrg-top-30 help-text'}>
                                        If you're unable to find a suitable date and time or need assistance with
                                        booking your appointment, please call us at <span> (000) 000-0000</span> .
                                    </div>
                                </div>

                                <div className="d-flex ts-justify-content-center proceed-button">
                                    <ButtonComponent
                                        disabled={appointmentData?.sessions?.length === 0}
                                        onClick={() => {
                                            if (!appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.provider_id || !appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.appointment_date || !appointmentData?.sessions[appointmentData?.sessions?.length - 1]?.start_time) {
                                                CommonService._alert.showToast("Please Fill the empty field of selected appointment before proceeding to payment", "warning")
                                            } else {
                                                dispatch(setBookingAppointmentFlowNavigation("followup-appointment-payment-screen"))
                                            }
                                        }}
                                    >
                                        Proceed to Payment
                                    </ButtonComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                currentBookingAppointmentFlowNavigation === "followup-appointment-payment-screen" &&
                <div className={'client-type-screen d-flex'}>

                    <div className={'flex-1 appointment-details-holder pdd-30'}>
                        <div className={'d-flex justify-content-space-between align-items-center mrg-bottom-15'}>
                            <div className={'header-text'}>
                                Appointment Details
                            </div>
                            <div className={'d-flex'}>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center mrg-right-10'}>{selectedInjuryType === "initial_consultation" ? "Initial Consult" : "Follow-up Consult"}</div>
                                <div
                                    className={'tag-card-details-wrapper d-flex align-items-center'}>
                                    <div className={'mrg-right-5'}>
                                        <ImageConfig.WatchTimer color={"white"}/>
                                    </div>
                                    <div>
                                        {selectedTimeDurationAndAmount?.duration} min
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(internalScreen !== "booking-for-screen" && familyClientDetails) &&
                            <div className={'selected-client-details mrg-bottom-15'}>
                                Client: {familyClientDetails?.client_details?.first_name}&nbsp;{familyClientDetails?.client_details?.last_name} | {CommonService.formatPhoneNumber(familyClientDetails?.client_details?.primary_contact_info?.phone)}

                            </div>}
                        {(internalScreen !== "booking-for-screen" && appointmentForType === "my-self") &&
                            <div className={'selected-client-details mrg-bottom-15'}>
                                Client: {currentUser?.profile_viewing_as?.first_name ? currentUser?.profile_viewing_as?.first_name : currentUser?.first_name}&nbsp;{currentUser?.profile_viewing_as?.last_name ? currentUser?.profile_viewing_as?.last_name : currentUser?.last_name} | {CommonService.formatPhoneNumber(currentUser?.profile_viewing_as?.primary_contact_info?.phone ? currentUser?.profile_viewing_as?.primary_contact_info?.phone : currentUser?.primary_contact_info?.phone)}
                            </div>}
                        <div className={'category-details-holder_book_appointment_flow d-flex'}>
                            <div className={'active-status-show-on-card'}></div>
                            <div className={'pdd-20'}>
                                <div className={'d-flex align-items-center'}>
                                    <div>
                                        <img className={'details-image'} src={selectedServiceDetails?.image?.url}
                                             width={60} height={40}
                                             alt={selectedServiceDetails?.name}/>
                                    </div>
                                    <div className={'category-details-text-wrapper mrg-left-20'}>
                                        <div className={'service-therapy-text'}>
                                            {selectedCategoryDetails?.name}
                                        </div>
                                        <div
                                            className={'category-name-text-in-details mrg-bottom-5'}>{selectedServiceDetails?.name}</div>
                                        <div>
                                            <Paragraph className={'category-description-wrapper'}
                                                       ellipsis={{rows: 2, expandable: false}}>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                                            </Paragraph>
                                            <div className={"appointment-blue-text"} onClick={() => {
                                                setIsCategoryServiceModalOpen(true)
                                            }}>
                                                Read More
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'facility-details-holder mrg-top-15'}>
                            <div className={'mrg-bottom-10 facility-details-header-text'}>Facility Details</div>
                            <div className={'d-flex  align-items-center'}>
                                <div><ImageConfig.FacilityIcon/></div>
                                <div className={'mrg-left-15'}>
                                    <div className={'facility-name-text'}>{facilityDetails?.name}</div>
                                    <div
                                        className={'facility-address-text'}>{CommonService?.formatAddressBillAppointment(facilityDetails?.address)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="payment-follow-up-appointments-container d-flex flex-direction-column">
                            <div className={'d-flex justify-content-space-between mrg-bottom-15'}>
                                <div className="appointments-header">Total
                                    Appointments: {appointmentData?.sessions?.length || "NA"}</div>
                                {/*<div>*/}
                                {/*    + Add new Appointment*/}
                                {/*</div>*/}
                            </div>

                            <div className="appointments-scroll flex-1">
                                <div className="appointments-list">
                                    <div className="appointments-header-row">
                                        <div className="column-header-provider">Provider</div>
                                        <div className="column-header">Date</div>
                                        <div className="column-header">Time</div>
                                        {/*<div className="column-header"></div>*/}
                                    </div>
                                    <div className={'appointments-list-body-follow-up'}>
                                        {appointmentData?.sessions?.map((appointment: any, index: number) => (
                                            <div key={index} className="appointment-row">
                                                <div className="provider-name">
                                                    {appointment.provider_details.first_name} {appointment.provider_details.last_name}
                                                </div>
                                                <div
                                                    className="appointment-date">{CommonService.getSystemFormatTimeStamp(appointment.appointment_date)}</div>
                                                <div className="appointment-time">
                                                    {CommonService.getHoursAndMinutesFromMinutes(appointment?.start_time)}
                                                </div>
                                                {/*<div className="action-buttons">*/}
                                                {/*    <div className={'cursor-pointer'} onClick={() => {*/}
                                                {/*        setSelectedDateForProviderFollowUp(appointment?.appointment_date)*/}
                                                {/*        setSelectedProviderDetails(appointment?.provider_details)*/}
                                                {/*    }}>*/}
                                                {/*        <ImageConfig.EditIcon width={18} height={18}*/}
                                                {/*                              color={"#66FFE0"}/>*/}
                                                {/*    </div>*/}
                                                {/*    <div className={'mrg-left-10 cursor-pointer'} onClick={() => {*/}
                                                {/*        handleRemoveSession(appointment)*/}
                                                {/*        UnBlockTheFollowUpAppointmentApiCall(appointment?.appointment_date, appointment?.start_time, appointment?.end_time)*/}
                                                {/*    }}>*/}
                                                {/*        <ImageConfig.DeleteIcon width={18} height={18}*/}
                                                {/*                                color={"#E84142"}/>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={'flex-1 client-type-form-holder'}>
                        <div
                            className={'previous-button d-flex mrg-bottom-20 pdd-15 justify-content-space-between align-items-center'}>
                            <div className={'d-flex'}>
                                <div
                                    className={'back-arrow-holder d-flex ts-justify-content-center  cursor-pointer align-items-center'}
                                    onClick={() => {
                                        dispatch(setBookingAppointmentFlowNavigation("followup-appointment-booking-screen"));
                                    }}>
                                    <ImageConfig.LeftArrow color={"#07213C"}/>
                                </div>
                                <div
                                    className={'previous-text d-flex ts-justify-content-center align-items-center mrg-left-10'}>
                                    Previous
                                </div>
                            </div>
                            <div>
                                {
                                    (remainingTimeForFollowUpBooking > 0) &&
                                    <div
                                        className={'time-remaining-wrapper-book-appointment d-flex ts-justify-content-center align-items-center'}>
                                        <div className={'mrg-right-10 d-flex ts-justify-content-center'}>
                                            <ToolTipComponent
                                                showArrow={true}
                                                position={"bottom"}
                                                tooltip={<div>The clock is ticking – this timer shows how long we’ll
                                                    hold your appointment spot during checkout. If time runs out, other
                                                    clients will have a chance to select this spot. However, you can
                                                    still book this time slot after the timer ends, if it's still
                                                    available.</div>}>
                                                <ImageConfig.InfoFilledIcon
                                                    color={"#E84142"}/>
                                            </ToolTipComponent>
                                        </div>
                                        <div>
                                            Time
                                            Remaining: {CommonService.getMinsAndSecondsFromSeconds(remainingTimeForFollowUpBooking).minutes + " : " + CommonService.getMinsAndSecondsFromSeconds(remainingTimeForFollowUpBooking).seconds}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className={'checkout-screen-component'}>
                            <div className={'d-flex  align-items-center justify-content-center'}>
                                <div className={'mrg-bottom-30'}>
                                    <div className={'welcome-back-text'}>Secure Checkout
                                    </div>
                                </div>
                            </div>
                            <div className={'mrg-left-40 mrg-right-20 secure-checkout-wrapper'}>
                                <div>
                                    <div className={'total-amount-header'}>Total Amount (Incl. tax)</div>
                                    <div
                                        className={'total-amount-value'}>${selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length}</div>
                                </div>
                                <div className={'login-form-subtext mrg-bottom-10 mrg-top-25'}>
                                    Add a gift card or promotion code or voucher
                                </div>
                                <div className={'d-flex'}>
                                    <div className={'flex-1 code-input-wrapper'}>
                                        <InputComponent value={checkOutCode} placeholder={'Enter Code'} fullWidth
                                                        endIcon={
                                                            checkOutCode &&
                                                            <div className={'cursor-pointer'} onClick={() => {
                                                                setCheckOutCode(null);
                                                                setCouponCodeAppliedData(null)
                                                            }}>
                                                                <ImageConfig.InputCrossIcon/>
                                                            </div>
                                                        }
                                                        onChange={(code: any) => {
                                                            setCheckOutCode(code);
                                                            setCouponCodeAppliedData(null)
                                                        }}/>
                                    </div>
                                    <div className={'d-flex justify-content-center align-items-center mrg-left-15'}>
                                        <ButtonComponent
                                            disabled={!checkOutCode || isCouponCodeDataLoading || couponCodeAppliedData}
                                            isLoading={isCouponCodeDataLoading}
                                            onClick={() => {
                                                ApplyCouponApiCall()
                                            }}
                                            className={'button-apply-code'}
                                            variant={'outlined'}
                                            color={'accent'}
                                        >

                                            {couponCodeAppliedData ? "Applied" : "Apply"}
                                        </ButtonComponent>
                                    </div>
                                </div>
                                <div>
                                    <div className={'mrg-top-25 mrg-bottom-15 checkout-summary-header'}>Checkout
                                        Summary
                                    </div>
                                    <div className={'d-flex justify-content-space-between mrg-bottom-10'}>
                                        <div className={'amount-sub-header'}>Amount (Incl. tax)</div>
                                        <div
                                            className={'amount-sub-header-value'}>${selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length}</div>
                                    </div>
                                    <div className={'d-flex justify-content-space-between mrg-bottom-25'}>
                                        <div className={'amount-sub-header'}>Discount</div>
                                        <div
                                            className={'amount-sub-header-value'}>
                                            {(couponCodeAppliedData && couponCodeAppliedData?.discount_type === "percentage") &&
                                                <div>
                                                    ${CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount)}
                                                </div>
                                            }
                                            {(couponCodeAppliedData && couponCodeAppliedData?.discount_type === "amount") &&
                                                <div>
                                                    ${couponCodeAppliedData?.amount}
                                                </div>
                                            }
                                            {!couponCodeAppliedData &&
                                                <div>
                                                    No Coupon Applied
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className={'d-flex justify-content-space-between'}>
                                        <div className={'total-amount-sub-header'}>Total Amount (Incl. tax)</div>
                                        <div
                                            className={'total-amount-sub-value'}>$
                                            {!couponCodeAppliedData &&
                                                <span>
                                                    {Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length)}
                                                </span>}
                                            {couponCodeAppliedData &&
                                                <span>
                                                    {Number(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length) - (couponCodeAppliedData?.discount_type === "percentage" ? CommonService.calculateDiscountedAmount(selectedTimeDurationAndAmount?.amount * appointmentData?.sessions?.length, couponCodeAppliedData?.percentage, couponCodeAppliedData?.max_discount_amount) : couponCodeAppliedData?.amount)}
                                                </span>}
                                        </div>
                                    </div>
                                    <div className={''}>
                                        <div>
                                            <CheckBoxComponent label={''}
                                                               value={isAttendancePolicyChecked}
                                                               onChange={() => setIsAttendancePolicyChecked(prev => !prev)}
                                            />
                                        </div>
                                        <div className={'mrg-left-30'}> Reviewed the
                                            <span className={'blue-text'}
                                                  onClick={() => {
                                                      setIsAttendanceModalOpen(true);
                                                  }}> Attendance/Cancellation Policy.</span>
                                        </div>
                                    </div>
                                    <div>
                                        <ButtonComponent
                                            disabled={!isAttendancePolicyChecked}
                                            className={'mrg-top-40'}
                                            onClick={() => {
                                                //  BookAppointmentApiCall();
                                                setIsCheckoutConfirmationModalOpen(true)
                                            }}
                                            //   onClick={handleSecureCheckout}
                                            //  isLoading={isCheckingOutInProgress}
                                            fullWidth={true}
                                        >
                                            Check Out
                                        </ButtonComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }
        </div>
    )
}

export default BookAppointmentFlowModalComponent;

